import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteCustomer,
  getCustomer,
  getCustomerAccounts,
  suspendCustomer,
  getPendingReasons,
  updateCustomer,
  updateCustomerAddress,
  addIssue,
  updateNextOfKin,
  addNextOfKin,
  uploadFile,
  getLoanSummary,
  getNormaLoanDetails,
  getEmergencyLoanDetails,
  getDevelopmentLoanDetails,
  getJijengeLoanDetails,
  adminResetPassword,
  unSuspendMemberAccount,
  getAddressInfo,
  createAccount,
  createSavingsAccount,
  updateUserInfo,
  registerSharesSave,
  hasCompletedMembership,
  getCounties,
  getCountries,
  temporaryPassword,
  uploadKenyaIdBack,
  uploadKenyaIdFront,
  uploadPassport,
} from "../../sdk/customers/customers";
import { verifyCustomerOtp, sendMemberOtp } from "../../sdk/auth/auth";
import { toast } from "react-toastify";
import EditPersonalInfo from "../../components/Modals/edit-customer/EditPersonalInfo";
import EditNextOfKin from "../../components/Modals/edit-customer/EditNextOfKin";
import EditAdditionalInfo from "../../components/Modals/edit-customer/EditAdditionalInfo";
import ViewCustomerDocument from "../../components/Modals/edit-customer/ViewCustomerDocument";
import ViewID from "../../components/Modals/edit-customer/ViewID";
import EditIdentity from "../../components/Modals/edit-customer/Edit_identity";
import EditSelfie from "../../components/Modals/edit-customer/Edit_selfie";
import MemberDetails from "../../components/Modals/edit-customer/MemberDetails";
import NewSelfiePhoto from "../../components/Modals/pending_Account/newSelfiePhoto";
import MpesaLoading from "../../components/Modals/registration/MpesaLoading";
import MpesaProcessing from "../../components/Modals/registration/MpesaProcessing";
import EditMetaData from "../../components/Modals/edit-customer/EditMetaData";
import ProceedModal from "../../components/Modals/edit-customer/ProceedModal";
import LoadingButtons from "../../components/Modals/edit-customer/LoadingButtons";
import ContinueModal from "../../components/Modals/edit-customer/ContinueModal";
import SaveChanges from "../../components/Modals/edit-customer/SaveChanges";
import DetailSavedSuccessfully from "../../components/Modals/edit-customer/DetailSavedSuccessfully";
import PaymentPromptSent from "../../components/Modals/registration/PromptSent";
import PaymentNotReceived from "../../components/Modals/registration/PaymentNotReceived";
import PaymentSuccessful from "../../components/Modals/registration/PaymentSuccessful";
import UploadedKYCdocs from "../../components/Modals/pending_Account/uploadedKYCdoc";
import EditToApprove from "../../components/Modals/pending_Account/editToApprove";
import SuccessApproveAccount from "../../components/Modals/pending_Account/successApproveAccount";
import RejectIdSuccess from "../../components/Modals/pending_Account/rejectIdSuccess";
import ViewSelfiePhoto from "../../components/Modals/pending_Account/viewSelfiePhoto";
import SeeIdentityDoc from "../../components/Modals/pending_Account/seeIdentityDoc";
import RejectionReason from "../../components/Modals/pending_Account/rejectionReason";
import UploadNewID from "../../components/Modals/pending_Account/uploadNewID";
import NoteToReject from "../../components/Modals/pending_Account/noteToReject";
import RejectAccountApproval from "../../components/Modals/pending_Account/rejectAccountApproval";
import ApprovalNote from "../../components/Modals/pending_Account/approvalNote";
import AccountApproval from "../../components/Modals/pending_Account/accountApproval";
import CloseAccountSuccess from "../../components/success-modals/CloseAccountSuccess";
import LoadingModal from "../../components/Modals/add_customer/loadingModal";
import EmailPrompt from "../../components/Modals/prompts/EmailPrompt";
import FailModal from "../../components/Modals/add_customer/failToCapture";
import LoadingPanel from "../../components/Modals/add_customer/loadingPanel";
import FailPanel from "../../components/Modals/add_customer/failPanel";
import MobilePrompt from "../../components/Modals/prompts/MobilePrompt";
import OtpEmail from "../../components/Modals/edit-customer/OtpEmail";
import OtpMobile from "../../components/Modals/edit-customer/OtpMobile";
import SuspendCustomerPrompt from "../../components/Modals/prompts/SuspendCustomerPrompt";
import DeleteAccountPop from "../../components/Modals/suspend-account/DeleteAccountPop";
import CustomerResetPassword from "../../components/Modals/edit-customer/customerResetPassword";
import PasswordResetLink from "../../components/Modals/edit-customer/passwordResetLink";
import UnsuspendMember from "../../components/Modals/edit-customer/unsuspendMember";
import SuccessUnsuspendedMember from "../../components/Modals/edit-customer/successUnsuspendedMember";
import NewEmail from "../../components/Modals/edit-customer/newEmail";
import SelectDocument from "../../components/Modals/documentsUploads/selectDocument";
import { client } from "../../sdk/client/client";
import NewsEmailSuccessfully from "../../components/Modals/edit-customer/newEmailSuccessfully";
import FeePayment from "../../components/Modals/registration/Fee_Payment";
import CreateAccounts from "../../components/Modals/registration/CreateAccount";
import AccountCreatedSuccessfully from "../../components/Modals/registration/AccountCreated";
import { PERMISSIONS } from "../../contexts/permissions";
import { PermissionGate } from "../../helpers/PermissionGate";
import IdentityScanningPanel from "../../components/Modals/add_customer/identityScanningPanel";
import FirstModal from "../../components/Modals/add_customer/personal_Info";
import SuccessSlidePanel from "../../components/Modals/add_customer/successSlidePanel";
import NextofKinPanel from "../../components/Modals/add_customer/NextofKinPanel";
import AdditionalInfoPanel from "../../components/Modals/add_customer/AdditionalInfoPanel";

const Customer = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState({});

  const [customerAccounts, setCustomerAccounts] = useState({});

  const [flashLoan, setFlashLoan] = useState([]);

  const [normalLoan, setNormalLoan] = useState([]);
  const [emergencyLoan, setEmergencyLoan] = useState([]);
  const [developmentLoan, setDevelopmentLoan] = useState([]);
  const [jijengeLoan, setJijengeLoan] = useState([]);

  const [pendingReasons, setPendingReasons] = useState([]);

  const [colors, setColors] = useState([
    "#005C53",
    "#8ED6A8",
    "#042940",
    "#716B6B",
    "#17bfe2",
  ]);

  const formatDateTime = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return new Date(dateString).toLocaleString("en-GB", options);
  };

  const fetchCustomer = async (id) => {
    try {
      const res = await getCustomer(id);
      const customerData = res?.data;

      const documents = [
        {
          type: "Selfie Image",
          url: customerData.selfie_image,
          dateUploaded: customerData.createdAt,
          lastModified: customerData.updatedAt,
          documentIdNumber: "",
        },
      ];

      const fullCustomer = {
        ...customerData,
        documents,
      };

      setCustomer(fullCustomer);
      return fullCustomer;
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const fetchPendingReasons = async (id) => {
    try {
      const res = await getPendingReasons(id);

      setPendingReasons(res?.data || []);
    } catch (error) {
      console?.error("Error fetching customer data:", error);
    }
  };

  const fetchMembershipStatus = async (id) => {
    try {
      await hasCompletedMembership(id);
    } catch (error) {
      console?.error("Error fetching membership status:", error);
    }
  };

  const initials = `${customer?.firstname?.slice(0, 1) || "N/"}${
    customer?.lastname?.slice(0, 1) || "A"
  }`;

  const fetchCustomerAccounts = async (id) => {
    const res = await getCustomerAccounts(id);
    setCustomerAccounts(res?.data);
  };

  const fetchLoanSummary = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer.mobileno?.split("+")[1]
      : customer?.mobileno;

    const res = await getLoanSummary(mobile);
    setFlashLoan(res);
  };

  const fetchNormaLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getNormaLoanDetails(mobile);
    setNormalLoan(res);
  };

  const fetchEmergencyLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getEmergencyLoanDetails(mobile);
    setEmergencyLoan(res);
  };

  const fetchDevelopmentLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getDevelopmentLoanDetails(mobile);
    setDevelopmentLoan(res);
  };

  const fetchJijengeLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getJijengeLoanDetails(mobile);
    setJijengeLoan(res);
  };

  const navigateToTransactions = (
    custId,
    id,
    account_number,
    color,
    loan_code,
    prod_ID,
  ) => {
    navigate(`/dashboard/customers/${custId}/${id}`, {
      state: { account_number, color, loan_code, prod_ID },
    });
  };

  useEffect(() => {
    fetchCustomer(id);
    fetchPendingReasons(id);
    fetchCustomerAccounts(id);
    fetchMembershipStatus(id);
  }, [id]);

  useEffect(() => {
    fetchLoanSummary(customer);
    fetchNormaLoan(customer);
    fetchEmergencyLoan(customer);
    fetchDevelopmentLoan(customer);
    fetchJijengeLoan(customer);
  }, [customer]);

  const [showBalance, setShowBalance] = useState({});

  const toggleBalanceVisibility = (accountId) => {
    setShowBalance((prevVisibility) => ({
      ...prevVisibility,
      [accountId]: !prevVisibility[accountId],
    }));
  };

  const [editCustomerOpen, setEditCustomerOpen] = useState(false);

  const handleOpenEditCustomerPersonalInfo = () => {
    setEditCustomerOpen(true);
  };

  const handleCloseEditCustomerPersonalInfo = () => {
    setEditCustomerOpen(false);
  };

  const [dateOfBirth, setDateOfBirth] = useState("");
  const [fullName, setFullName] = useState("");
  const [relationship, setRelationship] = useState("");
  const [location, setLocation] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    const nextOfKinRelationship =
      customer?.nextOfKins?.length > 0
        ? customer.nextOfKins[0]?.relationship
        : null;
    const nextOfKinFullName =
      customer?.nextOfKins?.length > 0 ? customer.nextOfKins[0]?.name : null;
    const nextOfKinMobileNumber =
      customer?.nextOfKins?.length > 0
        ? customer.nextOfKins[0]?.phoneNumber
        : null;
    const nextOfKinLocation =
      customer?.nextOfKins?.length > 0
        ? customer.nextOfKins[0]?.location
        : null;
    const nextOfKinDateOfBirth =
      customer?.nextOfKins?.length > 0
        ? customer.nextOfKins[0]?.dateOfBirth
        : null;
    setRelationship(nextOfKinRelationship);
    setFullName(nextOfKinFullName);
    setDateOfBirth(nextOfKinDateOfBirth);
    setMobileNumber(nextOfKinMobileNumber);
    setLocation(nextOfKinLocation);
  }, [customer]);

  const [editNextOfKinOpen, setEditNextOfKinOpen] = useState(false);
  const handleOpenEditNextOfKin = () => {
    setEditNextOfKinOpen(true);
  };
  const handleCloseEditNextOfKin = () => {
    setEditNextOfKinOpen(false);
  };

  const [editAdditionalInfoOpen, setEditAdditionalInfoOpen] = useState(false);

  const [selectedDocument, setSelectedDocument] = useState(null);

  const [ViewCustomerDocumentOpen, setViewCustomerDocumentOpen] =
    useState(false);
  const [ViewIDOpen, setViewIDOpen] = useState(false);

  const handleOpenEditAdditionalInfo = () => {
    setEditAdditionalInfoOpen(true);
  };

  const handleViewCustomerDocument = (document) => {
    setSelectedDocument({
      url: document?.url,
      dateUploaded: document?.dateUploaded,
      type: document?.type,
      documentIdNumber: document?.documentIdNumber,
      lastModified: document?.lastModified,
    });
    setViewCustomerDocumentOpen(true);
  };

  const handleViewID = () => {
    setViewIDOpen(true);
  };

  const handleCloseViewCustomerDocument = () => {
    setSelectedDocument(null);
    setViewCustomerDocumentOpen(false);
  };

  const handleCloseViewID = () => {
    setViewIDOpen(false);
  };

  // const handleAuditDocument = () => {
  //   setViewCustomerDocumentOpen(false);
  // };

  const handleCloseEditAdditionalInfo = () => {
    setEditAdditionalInfoOpen(false);
  };

  const [identity, setIdentity] = useState("");

  useEffect(() => {
    if (customer?.identification) {
      setIdentity(customer?.identification);
    }
  }, [customer]);

  useEffect(() => {
    if (customer) {
      setCustomerEditDetails({
        firstname: customer?.firstname || "",
        lastname: customer?.lastname || "",
        middlename: customer?.middlename || "",
        gender: customer?.gender || "",
        dob: customer?.dob || "",
        citizenship: customer?.citizenship || "",
        identification: customer?.identification || "",
        email: customer?.email || "",
        mobileno: customer?.mobileno || "",
        username: customer?.username || "",
      });
    }
  }, [customer]);

  const [customerEditDetails, setCustomerEditDetails] = useState({
    firstname: "",
    lastname: "",
    middlename: "",
    gender: "",
    dob: "",
    citizenship: "",
    identification: "",
    email: "",
    mobileno: "",
    username: "",
  });

  useEffect(() => {
    if (customer) {
      const firstAddress = customer?.addresses?.[0] || {};
      setEditAdditionalDetails({
        kraPin: customer?.kraPin || "",
        occupation: customer?.occupation || "",
        income_range: customer?.income_range || "",
        employment_type: customer?.employment_type || "",
        country_of_residence: customer?.country_of_residence || "",
        county: firstAddress?.county || "",
        subcounty: firstAddress?.subcounty || "",
        physical_address: firstAddress?.physical_address || "",
      });
    }
  }, [customer]);

  const accountsArray = Array.isArray(customerAccounts)
    ? customerAccounts
    : customerAccounts
      ? [customerAccounts]
      : [];

  const hasSharesAccount = accountsArray.some((acc) =>
    acc?.product?.name?.toLowerCase()?.includes("shares"),
  );

  const hasSavingsAccount = accountsArray.some((acc) =>
    acc?.product?.name?.toLowerCase()?.includes("savings"),
  );

  const ensureSharesAndSavingsAccounts = async (
    customerAccounts,
    customerId,
  ) => {
    const userId = localStorage.getItem("userID");
    const branchId = "71cbca39-4872-48fa-9129-c4ef3b20fb21";

    if (!hasSharesAccount) {
      await createAccount({
        product_id: "1f30885f-15d3-47b3-91e4-dda7013a9fcc",
        branch_id: branchId,
        customer_id: customerId,
        user_id: userId,
      });
    }

    if (!hasSavingsAccount) {
      await createAccount({
        product_id: "eab1ba28-4867-4762-a3aa-ab5d6e557482",
        branch_id: branchId,
        customer_id: customerId,
        user_id: userId,
      });
    }

    await updateCustomer(customerId, {
      onboarding_stage: "completed",
    });

    // Refresh accounts list from API
    const updatedAccounts = await fetchCustomerAccounts(customerId);
    return updatedAccounts;
  };

  const [editAdditionalDetails, setEditAdditionalDetails] = useState({
    kraPin: "",
    occupation: "",
    income_range: "",
    employment_type: "",
    country_of_residence: "",
    county: "",
    subcounty: "",
    physical_address: "",
  });

  const handleEditCustomerDetails = async () => {
    try {
      //  Update customer personal details
      await updateCustomer(id, customerEditDetails);

      // 2. Re-fetch updated customer (and await the actual data)
      const updatedCustomer = await fetchCustomer(id);

      if (updatedCustomer?.status?.toLowerCase() === "active") {
        const updatedAccounts = await fetchCustomerAccounts(id);
        await ensureSharesAndSavingsAccounts(updatedAccounts, id);
      }

      //  Reset state and refresh customer accounts
      setCustomerEditDetails({});
      handleCloseEditCustomerPersonalInfo();
      await fetchCustomerAccounts(id);

      toast?.success("Customer details updated successfully! 🎉");
    } catch (error) {
      const errorMessage =
        error?.message ||
        "Something went wrong while updating customer details.";
      toast?.error(errorMessage);
    }
  };

  const handleEditAdditionalInformation = async () => {
    try {
      const addressId = customer?.addresses?.[0]?.id;

      await Promise.all([
        updateCustomer(id, {
          kraPin: editAdditionalDetails?.kraPin,
          income_range: editAdditionalDetails?.income_range,
          occupation: editAdditionalDetails?.occupation,
          employment_type: editAdditionalDetails?.employment_type,
          country_of_residence: editAdditionalDetails?.country_of_residence,
        }),

        addressId
          ? updateCustomerAddress(addressId, {
              customer_id: id,
              county: editAdditionalDetails?.county,
              subcounty: editAdditionalDetails?.subcounty,
              physical_address: editAdditionalDetails?.physical_address,
            })
          : getAddressInfo({
              customer_id: id,
              county: editAdditionalDetails?.county,
              subcounty: editAdditionalDetails?.subcounty,
              physical_address: editAdditionalDetails?.physical_address,
            }),
      ]);

      //  Re-fetch updated customer
      await fetchCustomer(id);

      if (customer?.status?.toLowerCase() === "active") {
        await ensureSharesAndSavingsAccounts(customerAccounts, id);
      }

      setCustomerEditDetails({});

      handleCloseEditAdditionalInfo();

      await fetchCustomerAccounts(id);

      toast?.success("Customer information updated successfully! 🎉");
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong. Please try again later.";
      toast?.error(errorMessage);
    }
  };

  const [loading, setLoading] = useState(false);

  const handleEditNextOfKin = async () => {
    setLoading(true);
    try {
      const nextOfKinId = customer?.nextOfKins?.[0]?.id;

      const payload = {
        name: fullName,
        dateOfBirth,
        relationship,
        phoneNumber: mobileNumber,
        location,
      };

      if (nextOfKinId) {
        await updateNextOfKin(nextOfKinId, payload);
        toast?.success("Next of Kin updated successfully!");
        setCustomerEditDetails({});
      } else {
        await addNextOfKin(customer?.id, payload);
        toast?.success("Next of Kin added successfully!");
      }

      setCustomerEditDetails({});

      handleCloseEditNextOfKin();
      fetchCustomer(id);
      setFullName("");
      setDateOfBirth(null);
      setLocation("");
      setRelationship("");
      setMobileNumber("");

      fetchCustomer(id);
    } catch (error) {
      toast?.error(error?.message || "Error updating Next of Kin");
    } finally {
      setLoading(false);
    }
  };

  const handleNextOfKin = async () => {
    setLoading(true);

    try {
      const customerId = customer?.id || id;

      const payload = {
        name: fullName,
        dateOfBirth,
        relationship,
        phoneNumber: mobileNumber,
        location,
      };

      const onboardingUpdate = {
        onboarding_stage: "completed",
        // status: "Pending Payment",
      };

      // ✅ Run critical updates in parallel
      await Promise?.all([
        addNextOfKin(customerId, payload),
        updateCustomer(customerId, onboardingUpdate),
      ]);

      // const branchId = "71cbca39-4872-48fa-9129-c4ef3b20fb21";
      // const userId = localStorage?.getItem("userID");

      // const results = await Promise?.allSettled([
      //   createAccount({
      //     product_id: "1f30885f-15d3-47b3-91e4-dda7013a9fcc",
      //     branch_id: branchId,
      //     customer_id: id,
      //     user_id: userId,
      //   }),
      //   createSavingsAccount({
      //     product_id: "eab1ba28-4867-4762-a3aa-ab5d6e557482",
      //     branch_id: branchId,
      //     customer_id: id,
      //     user_id: userId,
      //   }),
      // ]);

      // const failed = results?.find((r) => r?.status === "rejected");

      // if (failed) {
      //   throw new Error(failed?.reason?.message);
      // }

      // // ✅ Non-blocking (don’t slow UI)
      // temporaryPassword({ email: customer?.email });

      // ✅ Fetch fresh data ONCE (ensures UI is accurate)
      await fetchCustomer(customerId);

      await fetchCustomerAccounts(id);

      // ✅ UI actions after success
      toast?.success("Next of Kin added successfully!");
      closeNextOfKinPanel();

      // ✅ Reset form
      setFullName("");
      setDateOfBirth(null);
      setLocation("");
      setRelationship("");
      setMobileNumber("");
    } catch (error) {
      toast?.error(error?.message || "Error updating Next of Kin");
    } finally {
      setLoading(false);
    }
  };

  const [closeAccountSuccessOpen, setCloseAccountSuccessOpen] = useState(false);

  const handleCloseAccountSuccess = () => {
    setCloseAccountSuccessOpen(false);
  };

  const [successApproveAccountOpen, setSuccessApproveAccountOpen] =
    useState(false);

  const handleCloseSuccessApproveAccount = () => {
    setSuccessApproveAccountOpen(false);
  };

  const [rejectIdSuccessOpen, setRejectIdSuccessOpen] = useState(false);

  const handleCloseRejectIdSuccess = () => {
    setRejectIdSuccessOpen(false);
  };

  const handleDeleteAccount = async () => {
    await deleteCustomer(id);
    await setIsDeleteAccountOpen(false);

    await setCloseAccountSuccessOpen(true);

    setTimeout(() => {
      navigate("/dashboard/customers");
    }, 2000);
  };

  const [emailPromptOpen, setEmailPromptOpen] = useState(false);
  const [isNewEmailOpen, setIsNewEmailOpen] = useState(false);

  const handleOpenNewEmail = () => {
    setIsNewEmailOpen(true);
  };

  const handleCloseNewEmail = async () => {
    setIsNewEmailOpen(false);
    try {
      await updateCustomer(id, { email: newEmail });

      await fetchCustomer(id);

      setIsNewsEmailSuccessfullyOpen(true);

      setTimeout(() => {
        setIsNewsEmailSuccessfullyOpen(false);
      }, 1500);

      toast?.success("Email updated successfully");
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong. Please try again later.";
      toast?.error(errorMessage);
    }
  };

  const handleOpenEmailPrompt = () => {
    setIsNewEmailOpen(true);
    setEditCustomerOpen(false);
  };
  const handleCloseEmailPrompt = () => {
    setEmailPromptOpen(false);
  };

  const handleProceed = () => {
    handleCloseEmailPrompt();
    handleOpenNewEmail();
  };

  const [isNewsEmailSuccessfullyOpen, setIsNewsEmailSuccessfullyOpen] =
    useState(false);

  const [mobilePromptOpen, setMobilePromptOpen] = useState(false);

  const handleOpenMobilePrompt = () => {
    setMobilePromptOpen(true);
  };
  const handleCloseMobilePrompt = () => {
    setMobilePromptOpen(false);
  };

  const [otpEmailOpen, setOtpEmailOpen] = useState(false);

  const handleOpenEmailOtp = () => {
    setOtpEmailOpen(true);
  };

  const [otpMobileOpen, setOtpMobileOpen] = useState(false);

  const handleOpenMobileOtp = () => {
    setOtpMobileOpen(true);
  };
  const handleCloseMobileOtp = () => {
    setOtpMobileOpen(false);
  };

  const [otp, setOtp] = useState("");

  const handleOtpVerification = async () => {
    try {
      const result = await verifyCustomerOtp(otp, customer?.mobileno);
      if (result?.message === "Success") {
        toast.success("Email verified");

        setOtpEmailOpen(false);
        setIsNewsEmailSuccessfullyOpen(true);

        setTimeout(() => {
          setIsNewsEmailSuccessfullyOpen(false);
        }, 1500);
      } else {
        toast.error("Invalid OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
    }
  };

  const handleCloseEmailOtp = async () => {
    setOtpEmailOpen(false);
    try {
      await Promise.all([
        updateCustomer(id, {
          email: customerEditDetails?.email,
        }),
      ]);
      await ensureSharesAndSavingsAccounts(customerAccounts, id);

      await fetchCustomer(id);

      if (customer?.status?.toLowerCase() === "active") {
        await ensureSharesAndSavingsAccounts(customerAccounts, id);
      }

      await fetchCustomerAccounts(id);

      toast?.success("Email updated successfully! 🎉");
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong. Please try again later.";

      toast?.error(errorMessage);
    }
  };

  const handleSuspendCustomer = async () => {
    const result = await suspendCustomer(id, "Suspended");
    fetchCustomer(id);
    fetchCustomerAccounts(id);
    handleCloseSuspendCustomerPrompt();
  };

  const [suspendCustomerPromptOpen, setSuspendCustomerPromptOpen] =
    useState(false);

  const handleCloseSuspendCustomerPrompt = () => {
    setSuspendCustomerPromptOpen(false);
  };

  const [isContinueEnabled, setIsContinueEnabled] = useState(false);
  const [isContinueEnab, setIsContinueEnab] = useState(false);
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [passportFile, setPassportFile] = useState(null);
  const [selfieFile, setSelfieFile] = useState(null);
  const [frontFileUrl, setFrontFileUrl] = useState("");
  const [backFileUrl, setBackFileUrl] = useState("");
  const [passportFileUrl, setPassportFileUrl] = useState("");

  const [identificationType, setIdentificationType] = useState("National Id");
  const [country, setCountry] = useState("Kenya");
  const [isIDModalOpen, setIsIDModalOpen] = useState(false);
  const [isLoadingButtons, setIsLoadingButtons] = useState(false);
  const [isSavedSuccessfully, setIsSavedSuccessfully] = useState(false);
  const [isPaymentPromptSent, setIsPaymentPromptSent] = useState(false);
  const [isPaymentNotReceived, setIsPaymentNotReceived] = useState(false);
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);
  const [isMpesaLoading, setIsMpesaLoading] = useState(false);
  const [isMpesaProcessing, setIsMpesaProcessing] = useState(false);

  const closeIDlModal = () => {
    setIsIDModalOpen(false);
  };

  const [uploadNewIDOpen, setUploadNewIDOpen] = useState(false);

  const closeUploadNewIDModal = () => {
    setUploadNewIDOpen(false);
  };

  const [isSelfieModalOpen, setIsSelfieModalOpen] = useState(false);
  const closeSelfieModal = () => {
    setIsSelfieModalOpen(false);
  };

  const [selfiePhotoModalOpen, setSelfiePhotoModalOpen] = useState(false);
  const closeSelfiePhotoModal = () => {
    setSelfiePhotoModalOpen(false);
  };

  const [isMetaDataOpen, setIsMetaDataOpen] = useState(false);

  const closeMetaData = () => {
    setIsMetaDataOpen(false);
  };

  const [isDeleteAccountOpen, setIsDeleteAccountOpen] = useState(false);
  const openDeleteAccountPop = () => {
    setIsDeleteAccountOpen(true);
  };
  const closeDeleteAccountPop = () => {
    setIsDeleteAccountOpen(false);
  };

  const sanitizeFileName = (file) => {
    const sanitizedName = file?.name?.replace(/\s+/g, "-");
    return new File([file], sanitizedName, { type: file?.type });
  };

  const [isProceedModalOpen, setIsProceedModalOpen] = useState(false);

  const closeProceedModal = () => {
    setIsProceedModalOpen(false);
  };

  const openProceedModal = () => {
    setIsProceedModalOpen(true);
  };
  const [isContinueModalOpen, setIsContinueModalOpen] = useState(false);

  const closeContinueModal = () => {
    setIsContinueModalOpen(false);
  };

  const [isSaveChanges, setIsSaveChanges] = useState(false);

  const closeSaveChanges = () => {
    setIsSaveChanges(false);
  };

  const submitSelfieFile = async () => {
    try {
      const selfieUrl = await uploadFile(selfieFile);
      console.log("photoUrl", selfieUrl);
      return selfieUrl;
    } catch (error) {
      console.error("Error submitting files:", error);
      toast.error(error?.message || "Error submitting files:", error);
      return null;
    }
  };

  const submitPhotoFile = async () => {
    try {
      const sanitizeFileName = (file) => {
        const sanitizedName = file?.name?.replace(/\s+/g, "-"); // replace spaces with -
        return new File([file], sanitizedName, { type: file?.type });
      };
      const sanitizedFile = sanitizeFileName(photoFile);
      const selfieUrl = await uploadFile(sanitizedFile);
      return selfieUrl;
    } catch (error) {
      console.error("Error submitting files:", error);
      toast.error(error?.message || "Error submitting files:", error);
      return null;
    }
  };

  const submitIdFrontFile = async () => {
    try {
      const idFrontUrl = await uploadFile(idFrontImage);
      return idFrontUrl;
    } catch (error) {
      console.error("Error submitting ID front file:", error);
      toast.error(error?.message || "Error submitting ID front file:", error);
      return null;
    }
  };

  const submitIdBackFile = async () => {
    try {
      const idBackUrl = await uploadFile(idBackImage);
      return idBackUrl;
    } catch (error) {
      console.error("Error submitting ID back file:", error);
      toast.error(error?.message || "Error submitting ID back file:", error);
      return null;
    }
  };

  const submitPassportFile = async () => {
    try {
      const passportUrl = await uploadFile(passportImage);
      return passportUrl;
    } catch (error) {
      console.error("Error submitting passport file:", error);
      toast.error(error?.message || "Error submitting passport file:", error);
      return null;
    }
  };

  const submitFiles = async () => {
    try {
      let frontUrl = "";
      let backUrl = "";
      let passportUrl = "";

      if (identificationType === "National Id") {
        if (frontFile) {
          frontUrl = await uploadFile(sanitizeFileName(frontFile));
          setFrontFileUrl(frontUrl);
        }

        if (backFile) {
          backUrl = await uploadFile(sanitizeFileName(backFile));
          setBackFileUrl(backUrl);
        }
      } else if (identificationType === "passport") {
        if (passportFile) {
          passportUrl = await uploadFile(sanitizeFileName(passportFile));
          setPassportFileUrl(passportUrl);
        }
      }

      return { frontUrl, backUrl, passportUrl };
    } catch (error) {
      console.error("Error submitting files:", error);
      toast.error(error?.message || "Error submitting files:", {
        autoClose: false,
      });
    }
  };

  const handleEditIdentity = () => {
    handleCloseViewID();

    setIsIDModalOpen(true);
  };

  const handleEditMetaData = () => {
    handleCloseViewID();

    setIsMetaDataOpen(true);
  };

  const handleEditSelfie = () => {
    setViewCustomerDocumentOpen(false);
    setIsSelfieModalOpen(true);
  };

  const handleSaveChangesButton = async () => {
    setIsSaveChanges(false);
    setIsProceedModalOpen(false);
    setIsLoadingButtons(true);

    try {
      if (identity) {
        // Update identity number
        await updateCustomer(id, {
          identification: identity,
        });

        await fetchCustomer(id);

        //  Ensure shares and savings accounts only if status is active
        if (customer?.status?.toLowerCase() === "active") {
          await ensureSharesAndSavingsAccounts(customerAccounts, id);
        }

        await fetchCustomerAccounts(id);
      } else {
        throw new Error("Failed to update the identity number.");
      }

      setIsLoadingButtons(false);
      setIsSavedSuccessfully(true);

      setTimeout(() => {
        setIsSavedSuccessfully(false);
      }, 1000);
    } catch (error) {
      setIsLoadingButtons(false);
      toast.error(
        error?.message || "Error in the complete registration process:",
        error,
      );
    }
  };

  const handleContinueButton = async () => {
    setIsSelfieModalOpen(false);
    setIsProceedModalOpen(false);
    setIsLoadingButtons(true);

    try {
      // Upload the selfie and get the URL
      const uploadedSelfieUrl = await submitSelfieFile();

      // Only proceed to update customer and fetch data if the selfie URL is set
      if (uploadedSelfieUrl) {
        await updateCustomer(id, {
          selfie_image: uploadedSelfieUrl,
        });

        await fetchCustomer(id);

        // 3️⃣ Ensure shares and savings accounts only if status is active
        if (customer?.status?.toLowerCase() === "active") {
          await ensureSharesAndSavingsAccounts(customerAccounts, id);
        }

        await fetchCustomer(id);
        await fetchCustomerAccounts(id);
      } else {
        throw new Error("Failed to upload selfie image.");
      }

      setIsLoadingButtons(false);
      setIsSavedSuccessfully(true);
      setSelfieFile(null);
      setTimeout(() => {
        setIsSavedSuccessfully(false);
      }, 1000);
    } catch (error) {
      setIsLoadingButtons(false);
      toast.error(
        error?.message || "Error in the complete registration process:",
        error,
      );
    }
  };

  const handleNextButtonClick = async () => {
    setIsIDModalOpen(false);

    setIsLoadingButtons(true);

    try {
      const { frontUrl, backUrl, passportUrl } = await submitFiles();

      let updateData = {};

      const payload = {
        firstname: firstName,
        lastname: lastName,
        middlename: middleName,
        dob: new Date(dob).toISOString(),
        gender: gender,
        identification: identification,
      };

      if (identificationType === "National Id") {
        updateData = {
          identification_type: identificationType,
          id_front_image: frontUrl,
          id_back_image: backUrl,
          // passport_image: "", // Clear passport image if not used
        };
      } else if (identificationType === "passport") {
        updateData = {
          // id_front_image: "", // Clear ID images if not used
          // id_back_image: "",
          identification_type: identificationType,
          passport_image: passportUrl,
        };
      }

      // Update customer data with the relevant URLs
      await updateCustomer(id, updateData);

      await updateUserInfo(id, payload);

      await fetchCustomer(id);

      closeMemberDetails();

      if (customer?.status?.toLowerCase() === "active") {
        await ensureSharesAndSavingsAccounts(customerAccounts, id);
      }

      await fetchCustomerAccounts(id);

      setIsLoadingButtons(false);
      setIsSavedSuccessfully(true);

      setTimeout(() => {
        setIsSavedSuccessfully(false);
        setFrontFile(null);
        setBackFile(null);
        setPassportFile(null);
      }, 1000);
    } catch (error) {
      setIsLoadingButtons(false);
      toast.error(
        error?.message || "Error in the complete registration process:",
        error,
      );
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [editToApprove, setEditToApprove] = useState(false);

  const closeEditToApprove = () => {
    setEditToApprove(false);
  };

  const handleOpenUploadedKYCModal = () => {
    setIsModalOpen(true);
  };

  const [viewSelfiePhotoOpen, setViewSelfiePhotoOpen] = useState(false);

  const handleOpenViewSelfiePhoto = () => {
    setIsModalOpen(false);

    setViewSelfiePhotoOpen(true);
  };

  const handleCloseViewSelfiePhoto = () => {
    setViewSelfiePhotoOpen(false);
  };

  const [seeIdentityDocOpen, setSeeIdentityDocOpen] = useState(false);

  const handleOpenSeeIdentityDoc = () => {
    setIsModalOpen(false);

    setSeeIdentityDocOpen(true);
  };

  const handleCloseSeeIdentityDoc = () => {
    setSeeIdentityDocOpen(false);
  };

  const [rejectionReason, setRejectionReason] = useState(false);
  const handleOpenRejectionReason = () => {
    setIsModalOpen(false);

    setRejectionReason(true);
  };

  const handleCloseRejectionReason = () => {
    setRejectionReason(false);
  };

  const [noteToReject, setNoteToReject] = useState(false);

  const handleOpenNoteToReject = () => {
    setRejectionReason(false);

    setNoteToReject(true);
  };

  const handleCloseNoteToReject = () => {
    setNoteToReject(false);
  };

  const [isRejectAccountApprovalOpen, setIsRejectAccountApprovalOpen] =
    useState(false);

  const openRejectAccountApproval = () => {
    setNoteToReject(false);

    setIsRejectAccountApprovalOpen(true);
  };
  const closeRejectAccountApproval = () => {
    setIsRejectAccountApprovalOpen(false);
  };

  const [approvalNote, setApprovalNote] = useState(false);
  const handleOpenApprovalNote = () => {
    setIsModalOpen(false);

    setApprovalNote(true);
  };

  const handleCloseApprovalNote = () => {
    setApprovalNote(false);
  };

  const [isAccountApprovalOpen, setIsAccountApprovalOpen] = useState(false);
  const openAccountApproval = () => {
    setApprovalNote(false);

    setIsAccountApprovalOpen(true);
  };

  const closeAccountApproval = () => {
    setIsAccountApprovalOpen(false);
  };

  const handleApproveAccount = async () => {
    try {
      // Decide status based on membership flag
      const newStatus =
        customer?.member === true ? "Active" : "Pending Payment";

      const result = await updateCustomer(id, {
        ...(customerEditDetails || {}),
        status: newStatus,
      });
      console.log(result);

      await closeAccountApproval();

      await fetchCustomer(id);

      if (customer?.status?.toLowerCase() === "active") {
        await ensureSharesAndSavingsAccounts(customerAccounts, id);
      }

      await setSuccessApproveAccountOpen(true);

      setTimeout(() => {
        navigate("/dashboard/customers");
      }, 2000);

      fetchCustomer(id);
      fetchCustomerAccounts(id);
    } catch (error) {
      toast?.error(
        error?.message || "Something went wrong while approving the account.",
      );
    }
  };

  const [note, setNote] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const handleRejectAccount = async () => {
    try {
      await updateCustomer(id, {
        status: "Cancelled",
      });

      // Concatenate selectedOption and note with a colon separator
      const reason = `${selectedOption}:${note}`;

      await addIssue({
        customer_id: id,
        field_name: "identification",
        reason: reason,
      });

      await closeRejectAccountApproval();

      await fetchCustomer(id);

      if (customer?.status?.toLowerCase() === "active") {
        await ensureSharesAndSavingsAccounts(customerAccounts, id);
      }

      await setRejectIdSuccessOpen(true);

      setTimeout(() => {
        navigate("/dashboard/customers");
      }, 2000);

      fetchCustomer(id);
      fetchCustomerAccounts(id);
    } catch (error) {
      console.error("Error adding issue:", error);
      // You can handle the error here if needed
    }
  };

  const [
    isCustomerResetPasswordModalOpen,
    setIsCustomerResetPasswordModalOpen,
  ] = useState(false);

  const openCustomerResetPassword = () => {
    setIsCustomerResetPasswordModalOpen(true);
  };

  const closeCustomerResetPassword = () => {
    setIsCustomerResetPasswordModalOpen(false);
  };

  const [isPasswordResetLinkOpen, setIsPasswordResetLinkOpen] = useState(false);

  const closePasswordResetLink = () => {
    setIsPasswordResetLinkOpen(false);
  };

  const handleAdminResetPassword = async () => {
    try {
      await adminResetPassword(id);
      toast?.success(
        "Password has been reset and sent to the customer's email.",
      );
      setIsCustomerResetPasswordModalOpen(false);
      setIsPasswordResetLinkOpen(true);
      setTimeout(() => {
        setIsPasswordResetLinkOpen(false);
      }, 2000);
    } catch (error) {
      toast.error("Failed to reset password. Please try again.");
    }
  };

  const [isUnsuspendMemberModalOpen, setIsUnsuspendMemberModalOpen] =
    useState(false);

  const openUnsuspendMember = () => {
    setIsUnsuspendMemberModalOpen(true);
  };

  const closeUnsuspendMember = () => {
    setIsUnsuspendMemberModalOpen(false);
  };

  const [isSuccessUnsuspendedMemberOpen, setIsSuccessUnsuspendedMemberOpen] =
    useState(false);
  const closeSuccessUnsuspendedMember = () => {
    setIsSuccessUnsuspendedMemberOpen(false);
  };

  const handleUnsuspendmember = async () => {
    try {
      await unSuspendMemberAccount(id);
      toast.success("Member has been successfully unsuspended.");
      setIsUnsuspendMemberModalOpen(false);
      setIsSuccessUnsuspendedMemberOpen(true);

      fetchCustomer(id);
      setTimeout(() => {
        setIsSuccessUnsuspendedMemberOpen(false);
      }, 2000);
    } catch (error) {
      toast.error("Failed to unsuspend member. Please try again.");
    }
  };

  const formatDate = (dateString) => {
    const [day, month, year] = dateString?.split(".");
    return `${year}-${month}-${day}`;
  };

  const [isloadingModal, setIsLoadingModal] = useState(false);
  const closeLoadingModal = () => {
    setIsLoadingModal(false);
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [gender, setGender] = useState("");
  const [username, setUsername] = useState("");
  const [dob, setDob] = useState("");
  const [identification, setIdentification] = useState("");

  const [passportNumber, setPassportNumber] = useState("");
  const [dateOfIssue, setDateOfIssue] = useState("");
  const [dateOfExpiry, setDateOfExpiry] = useState("");
  const [personalNumber, setPersonalNumber] = useState("");

  const [isFailModal, setIsFailModal] = useState(false);

  const closeFailModal = () => {
    setIsFailModal(false);
  };

  const [isMemberDetailsOpen, setIsMemberDetails] = useState(false);
  const openMemberDetails = () => {
    setIsMemberDetails(true);
  };
  const closeMemberDetails = () => {
    setIsMemberDetails(false);
  };

  const identityFiles = async () => {
    setIsContinueModalOpen(false);
    setIsIDModalOpen(false);
    setIsLoadingModal(true);

    try {
      let formData = new FormData();

      let frontUrl = "";
      let backUrl = "";
      let passportUrl = "";

      // File upload regardless of whether file is readable or not
      if (identificationType === "National Id") {
        try {
          const [uploadedFront, uploadedBack] = await Promise.all([
            frontFile
              ? uploadFile(sanitizeFileName(frontFile))
              : Promise?.resolve(""),
            backFile
              ? uploadFile(sanitizeFileName(backFile))
              : Promise?.resolve(""),
          ]);

          frontUrl = uploadedFront;
          backUrl = uploadedBack;

          setFrontFileUrl(frontUrl);
          setBackFileUrl(backUrl);
        } catch (fileError) {
          console.error("Upload failed:", fileError);
        }

        formData?.append("file", frontFile || "");
        formData?.append("dob", "");
        formData?.append("identification", "");
        formData?.append("side", "");
        formData?.append("userId", "");
        formData?.append("firstname", "");
        formData?.append("lastname", "");
      } else if (identificationType === "passport") {
        try {
          if (passportFile)
            passportUrl = await uploadFile(sanitizeFileName(passportFile));
          setPassportFileUrl(passportUrl);
        } catch (fileError) {
          console.warn(
            "Error reading Passport file, proceeding without readable file",
          );
        }

        formData?.append("file", passportFile || ""); // Proceed even if the file is not readable
        formData?.append("dob", "");
        formData?.append("identification", "");
        formData?.append("side", "");
        formData?.append("userId", "");
        formData?.append("firstname", "");
        formData?.append("lastname", "");
      }

      const endpoint =
        identificationType === "National Id"
          ? "/api/v1/kyc-validation/kenya-id"
          : "/api/v1/kyc-validation/passport";

      const response = await client.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const { data } = response?.data;

      if (identificationType === "National Id") {
        const { idNumber, fullNames, dateOfBirth, sex } = data || {};
        // const namesArray = fullNames?.split(" ");
        const namesArray = fullNames?.trim()?.split(/\s+/) || [];

        const firstName = namesArray[0];
        const lastName = namesArray[namesArray?.length - 1];
        const middleName = namesArray
          ?.slice(1, namesArray?.length - 1)
          ?.join(" ");

        setFirstName(firstName);
        setLastName(lastName);
        setGender(sex);
        setIdentification(idNumber);
        setMiddleName(middleName);
        setDob(formatDate(dateOfBirth));
      } else if (identificationType === "passport") {
        const {
          passportNumber,
          fullName,
          dateOfBirth,
          dateOfIssue,
          dateOfExpiry,
          personalNumber,
        } = data || {};

        const namesArray = fullName?.trim()?.split(/\s+/) || [];

        const firstName = namesArray[0];
        const lastName = namesArray[namesArray?.length - 1];
        const middleName = namesArray
          ?.slice(1, namesArray.length - 1)
          ?.join(" ");

        setFirstName(firstName);
        setMiddleName(middleName);
        setLastName(lastName);
        // setPassportNumber(passportNumber);
        setIdentification(passportNumber);
        setDob(dateOfBirth);
        setDateOfIssue(dateOfIssue);
        setDateOfExpiry(dateOfExpiry);
        setPersonalNumber(personalNumber);
      }

      // Check for empty entries
      const isNationalIdValid = identificationType === "National Id";
      const isPassportValid = identificationType === "passport";

      if (isNationalIdValid || isPassportValid) {
        openMemberDetails();
      } else {
        // Open failure modal
        setIsFailModal(true);
        // Ensure the ID modal remains open on failure
        setIsIDModalOpen(true);
      }
    } catch (error) {
      toast?.error(
        "Unable to process the uploaded document. Please upload a clear front side of a valid National ID.",
        {
          autoClose: false,
        },
      );
      setIsFailModal(true);

      setIsIDModalOpen(true);
    } finally {
      setIsLoadingModal(false);
    }
  };

  const handleContinueButtonClick = async () => {
    await identityFiles();
    await fetchCountries(id);
  };

  const [isSelectDocumentOpen, setIsSelectDocumentOpen] = useState(false);

  const closeSelectDoc = () => {
    setIsSelectDocumentOpen(false);
  };
  const [docSelected, setDocSelected] = useState("National_ID");

  const ContinueSelectDoc = () => {
    if (docSelected === "National_ID") {
      setIsIDModalOpen(true);
      closeSelectDoc();
    }

    if (docSelected === "Selfie") {
      setIsSelfieModalOpen(true);
      closeSelectDoc();
    }
  };

  const [savingsAmount, setSavingsAmount] = useState("");
  const [sharesAmount, setSharesAmount] = useState("");
  const [joiningFee, setJoiningFee] = useState(1000);
  const [mpesaNumber, setMpesaNumber] = useState("");
  const [isFeePaymentOpen, setIsFeePaymentOpen] = useState(false);

  const openFeePayment = () => {
    setIsFeePaymentOpen(true);
  };

  const closeFeePayment = () => {
    setIsFeePaymentOpen(false);
  };

  const formatMpesaNumber = (number) => {
    if (!number) return "";

    let cleaned = number.replace(/\D/g, "");

    if (cleaned.startsWith("0")) {
      return "+254" + cleaned.slice(1);
    }
    if (cleaned.startsWith("254")) {
      return "+254" + cleaned.slice(3);
    }
    if (number.startsWith("+254")) {
      return number;
    }
    if (cleaned.length === 9 && cleaned.startsWith("7")) {
      return "+254" + cleaned;
    }
    return "+254" + cleaned;
  };

  const handleRegisterShares = async () => {
    setIsMpesaProcessing(true);
    const formattedNumber = formatMpesaNumber(mpesaNumber);

    try {
      const result = await registerSharesSave(
        id,
        joiningFee,
        sharesAmount || 0,
        savingsAmount || 0,
        formattedNumber,
      );

      if (result?.statusCode === 200 && result?.data === "success") {
        // Step 1: Show Payment Prompt
        setIsPaymentPromptSent(true);

        setTimeout(() => {
          // Close prompt and show Mpesa loading
          setIsPaymentPromptSent(false);
          setIsMpesaLoading(true);

          let elapsedTime = 0;
          const interval = setInterval(async () => {
            elapsedTime += 1000;

            try {
              const res = await hasCompletedMembership(id);
              const status = res?.data?.exists;

              if (status) {
                clearInterval(interval);
                setIsMpesaLoading(false);
                setIsPaymentSuccessful(true);
                await updateCustomer(id, {
                  member: true,
                  membership: "active",
                  status: "Active",
                });
                await fetchCustomer(id);

                setTimeout(() => {
                  closeFeePayment();
                  setIsPaymentSuccessful(false);
                }, 2000);
              } else if (elapsedTime >= 25000) {
                clearInterval(interval);
                setIsMpesaLoading(false);
                setIsPaymentNotReceived(true);
              }
            } catch (err) {
              console.error("Error fetching membership status:", err);
              clearInterval(interval);
              setIsMpesaLoading(false);
              setIsPaymentNotReceived(true);
            }
          }, 2000);
        }, 3000);
      }
    } catch (error) {
      setIsMpesaLoading(false);
      closeFeePayment();
      toast.error(error?.response?.data?.message || "Error registering shares");
    } finally {
      setIsMpesaProcessing(false);
    }
  };

  const handleCancelTransaction = () => {
    closeFeePayment();
    setIsPaymentNotReceived(false);
  };

  const [isCreateAccountModalOpen, setIsCreateAccountModalOpen] =
    useState(false);

  const closeCreateAccount = () => {
    setIsCreateAccountModalOpen(false);
  };

  const [isAccountCreatedSuccessfully, setIsAccountCreatedSuccessfully] =
    useState(false);

  const handleCheckStatus = async () => {
    const fetchedCustomer = await fetchCustomer(id);

    if (fetchedCustomer?.member) {
      handleCancelTransaction();
    } else {
      setIsPaymentNotReceived(false);
      openFeePayment();
    }
  };

  const handleCreateAccount = async () => {
    if (!id) {
      toast?.error("Customer ID is missing");
      return;
    }

    const userId = localStorage.getItem("userID");
    if (!userId) {
      toast?.error("User session expired. Please log in again.");
      return;
    }

    setLoading(true);

    try {
      const branchId = "71cbca39-4872-48fa-9129-c4ef3b20fb21";

      const results = await Promise?.allSettled([
        createAccount({
          product_id: "1f30885f-15d3-47b3-91e4-dda7013a9fcc",
          branch_id: branchId,
          customer_id: id,
          user_id: userId,
        }),
        createSavingsAccount({
          product_id: "eab1ba28-4867-4762-a3aa-ab5d6e557482",
          branch_id: branchId,
          customer_id: id,
          user_id: userId,
        }),
      ]);

      const failed = results?.find((r) => r?.status === "rejected");

      if (failed) {
        throw new Error(failed?.reason?.message);
      }

      await fetchCustomerAccounts(id);
      setIsAccountCreatedSuccessfully(true);
      setIsCreateAccountModalOpen(false);
      toast?.success("Accounts created successfully!");
      setTimeout(() => {
        setIsAccountCreatedSuccessfully(false);
      }, 2000);
    } catch (error) {
      toast?.error(error?.message || "Failed to create accounts", {
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const [isProfileIncompleteModalOpen, setIsProfileIncompleteModalOpen] =
    useState(false);
  const [missingSections, setMissingSections] = useState([]);

  const openCreateAccount = () => {
    const missing = checkMissingInfo(customer);

    if (missing?.length > 0) {
      setMissingSections(missing);
      setIsProfileIncompleteModalOpen(true);
    } else {
      setIsCreateAccountModalOpen(true);
    }
  };

  const checkMissingInfo = (customer) => {
    const missing = [];

    // --- 1️⃣ Personal Info ---
    const personalFields = [
      "firstname",
      "lastname",
      "email",
      "mobileno",
      "dob",
      "username",
      "citizenship",
      "identification",
    ];
    const missingPersonal = personalFields.some(
      (f) => !customer?.[f] || customer?.[f] === "",
    );
    if (missingPersonal) missing.push("Personal Information");

    // --- 2️⃣ Additional Info ---
    const additionalChecks = [
      customer?.income_range,
      customer?.employment_type,
      customer?.occupation,
      customer?.country_of_residence,
      customer?.addresses?.[0]?.county,
      customer?.addresses?.[0]?.subcounty,
      customer?.addresses?.[0]?.physical_address,
    ];
    if (additionalChecks.some((v) => !v || v === "")) {
      missing.push("Additional Information");
    }

    // --- 3️⃣ Documents ---
    const hasSelfie = !!customer?.selfie_image;
    const hasFrontId = !!customer?.id_front_image;
    const hasBackId = !!customer?.id_back_image;
    if (!(hasSelfie && hasFrontId && hasBackId)) {
      missing.push("Documents");
    }

    // --- 4️⃣ Next of Kin ---
    const nok = customer?.nextOfKins?.[0];
    const nokRequired = [
      "name",
      "dateOfBirth",
      "relationship",
      "phoneNumber",
      "location",
    ];
    const nokIncomplete =
      !nok || nokRequired.some((f) => !nok?.[f] || nok?.[f] === "");
    if (nokIncomplete) missing?.push("Next of Kin Details");

    return missing;
  };
  const isAccountCreationReady = checkMissingInfo(customer)?.length === 0;

  const [counties, setCounties] = useState([]);
  const [countries, setCountries] = useState([]);

  const fetchCounties = async () => {
    try {
      const data = await getCounties();
      setCounties(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCounties();
  }, []);

  const fetchCountries = async () => {
    try {
      const data = await getCountries();

      setCountries(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchCountries();
  }, []);

  const isRegistration =
    customer?.onboarding_stage === "registration" ||
    customer?.onboarding_stage === "personal-information" ||
    customer?.onboarding_stage === "nextOfKin";

  const hasPersonalDetails =
    customer?.firstname &&
    customer?.lastname &&
    customer?.dob &&
    customer?.citizenship &&
    customer?.identification &&
    customer?.gender;

  const showEmptyState = isRegistration && !hasPersonalDetails;
  const showDetails = !isRegistration || hasPersonalDetails;
  const isAdditionalInfoEnabled = hasPersonalDetails;

  const [isIdentityPanelOpen, setIsIdentityPanelOpen] = useState(false);
  const [photoFile, setPhotoFile] = useState(null);
  const [idFrontImage, setIdFrontImage] = useState(null);

  const [idBackImage, setIdBackImage] = useState(null);
  const [passportImage, setPassportImage] = useState(null);

  const [kraPin, setKraPin] = useState("");
  const [monthlyIncome, setMonthlyIncome] = useState("");
  const [countryOfResidence, setCountryOfResidence] = useState("KENYA");
  const [county, setCounty] = useState("");
  const [subCounty, setSubCounty] = useState("");
  const [town, setTown] = useState("");
  const [physicalAddress, setPhysicalAddress] = useState("");
  const [landmark, setLandmark] = useState("");
  const [employment_type, setEmploymentType] = useState("");
  const [jobTitle, setJobTitle] = useState("");

  const openIdentityPanel = () => {
    setIsIdentityPanelOpen(true);
  };

  const closeIdentityPanel = () => {
    setIsIdentityPanelOpen(false);
  };

  const [isReviewPanelOpen, setIsReviewPanelOpen] = useState(false);

  const openReviewPanel = () => {
    setIsReviewPanelOpen(true);
  };

  const closeReviewPanel = () => {
    setIsReviewPanelOpen(false);
  };

  const [isFailPanelOpen, setIsFailPanelOpen] = useState(false);

  const closeFailPanel = () => {
    setIsFailPanelOpen(false);
  };
  const [isLoadingPanelOpen, setIsLoadingPanelOpen] = useState(false);

  const closeLoadingPanel = () => {
    setIsLoadingPanelOpen(false);
  };
  const [isSuccessPanelOpen, setIsSuccessPanelOpen] = useState(false);

  const closeSuccessPanel = () => {
    setIsSuccessPanelOpen(false);
  };
  const [isNextOfKinPanelOpen, setIsNextOfKinPanelOpen] = useState(false);
  const openNextOfKinPanel = () => {
    setIsNextOfKinPanelOpen(true);
  };

  const closeNextOfKinPanel = () => {
    setIsNextOfKinPanelOpen(false);
  };

  const hasAdditionalInfo =
    customer?.kraPin ||
    customer?.ssn ||
    customer?.income_range ||
    customer?.employment_type ||
    customer?.occupation ||
    customer?.country_of_residence ||
    (customer?.addresses?.length > 0 &&
      (customer.addresses[0]?.county ||
        customer.addresses[0]?.town ||
        customer.addresses[0]?.subcounty ||
        customer.addresses[0]?.street ||
        customer.addresses[0]?.physical_address));

  const hasCompleteAdditionalInfo =
    customer?.kraPin &&
    customer?.ssn &&
    customer?.income_range &&
    customer?.employment_type &&
    customer?.occupation &&
    customer?.country_of_residence &&
    customer?.addresses?.length > 0 &&
    customer?.addresses[0]?.county &&
    customer?.addresses[0]?.town &&
    customer?.addresses[0]?.subcounty &&
    customer?.addresses[0]?.street &&
    customer?.addresses[0]?.physical_address;

  const isRestrictedOnboardingStage =
    customer?.onboarding_stage === "registration" ||
    customer?.onboarding_stage === "personal-information";

  const showAdditionalInfoEdit =
    !isRestrictedOnboardingStage || hasCompleteAdditionalInfo;

  const isCompletedAndActive =
    customer?.onboarding_stage?.toLowerCase() === "completed" &&
    customer?.status?.toLowerCase() === "active";

  const hasCompleteNextofkin =
    customer?.nextOfKins &&
    customer?.nextOfKins?.length > 0 &&
    customer?.nextOfKins[0]?.name &&
    customer?.nextOfKins[0]?.dateOfBirth &&
    customer?.nextOfKins[0]?.relationship &&
    customer?.nextOfKins[0]?.phoneNumber &&
    customer?.nextOfKins[0]?.location;

  const isRestrictedOnboarding =
    customer?.onboarding_stage === "registration" ||
    customer?.onboarding_stage === "personal-information" ||
    customer?.onboarding_stage === "nextOfKin";
  const showNextofkinEdit = !isRestrictedOnboarding || hasCompleteNextofkin;

  const hasNextOfKin =
    customer?.nextOfKins &&
    customer?.nextOfKins?.length > 0 &&
    (customer?.nextOfKins[0]?.name ||
      customer?.nextOfKins[0]?.dateOfBirth ||
      customer?.nextOfKins[0]?.relationship ||
      customer?.nextOfKins[0]?.phoneNumber ||
      customer?.nextOfKins[0]?.location);

  const [showNextOfKinHint, setShowNextOfKinHint] = useState(false);
  const isNextOfKinEnabled = hasPersonalDetails && hasAdditionalInfo;

  const getNextOfKinError = () => {
    if (!hasPersonalDetails) return "Please complete personal details first";
    if (!hasAdditionalInfo)
      return "Please complete additional information first";
    return "";
  };

  const uploadedFiles = async () => {
    // Step 1: Close identity panel first
    closeIdentityPanel();

    // Step 2: Show loading panel
    setIsLoadingPanelOpen(true);

    try {
      let formData = new FormData();

      let passportUrl = "";

      // ======================
      // Upload files
      // ======================
      if (identificationType === "National Id") {
        try {
          const [frontUrl, backUrl] = await Promise.all([
            idFrontImage
              ? uploadFile(sanitizeFileName(idFrontImage))
              : Promise.resolve(""),
            idBackImage
              ? uploadFile(sanitizeFileName(idBackImage))
              : Promise.resolve(""),
          ]);

          setFrontFileUrl(frontUrl);
          setBackFileUrl(backUrl);

          formData.append("file", idFrontImage);
        } catch (fileError) {
          console.error("Upload failed:", fileError);
          throw fileError;
        }
      } else if (identificationType === "passport") {
        try {
          if (passportImage)
            passportUrl = await uploadFile(sanitizeFileName(passportImage));
          setPassportFileUrl(passportUrl);
        } catch (fileError) {
          console.warn("Error reading Passport file");
        }

        formData.append("file", passportImage || "");
      }

      // Common fields
      formData?.append("dob", "");
      formData?.append("identification", "");
      formData?.append("side", "");
      formData?.append("userId", "");
      formData?.append("firstname", "");
      formData?.append("lastname", "");

      const endpoint =
        identificationType === "National Id"
          ? "/api/v1/kyc-validation/kenya-id"
          : "/api/v1/kyc-validation/passport";

      const response = await client.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const { data } = response?.data;

      // ======================
      // Populate data
      // ======================
      if (identificationType === "National Id") {
        const { idNumber, fullNames, dateOfBirth, sex } = data || {};

        const namesArray = fullNames?.trim()?.split(/\s+/) || [];
        setFirstName(namesArray[0]);
        setLastName(namesArray[namesArray?.length - 1]);
        setMiddleName(namesArray?.slice(1, -1)?.join(" "));
        setGender(sex);
        setIdentification(idNumber);
        setDob(formatDate(dateOfBirth));
      } else {
        const {
          passportNumber,
          fullName,
          dateOfBirth,
          dateOfIssue,
          dateOfExpiry,
          personalNumber,
        } = data || {};

        const namesArray = fullName?.trim()?.split(/\s+/) || [];
        setFirstName(namesArray[0]);
        setLastName(namesArray[namesArray?.length - 1]);
        setMiddleName(namesArray?.slice(1, -1)?.join(" "));
        setIdentification(passportNumber);
        setDob(dateOfBirth);
        setDateOfIssue(dateOfIssue);
        setDateOfExpiry(dateOfExpiry);
        setPersonalNumber(personalNumber);
      }

      // ======================
      // SUCCESS FLOW
      // ======================
      setIsLoadingPanelOpen(false); // 🔥 CLOSE loading first
      setIsSuccessPanelOpen(true);

      setTimeout(() => {
        setIsSuccessPanelOpen(false);
        openReviewPanel(); // ✅ only success triggers review automatically
      }, 2000);
    } catch (error) {
      toast?.error(
        "Unable to process the uploaded document. Please upload a clear front side of a valid National ID.",
        {
          autoClose: false,
        },
      );

      // ======================
      // FAIL FLOW
      // ======================
      setIsLoadingPanelOpen(false);
      setIsFailPanelOpen(true);
    } finally {
      setIsLoadingPanelOpen(false);
    }
  };

  const handleGetFilesNames = async () => {
    if (isContinueEnab) {
      await uploadedFiles();
    }
  };

  const handleCompleteClick = async () => {
    try {
      // First upload selfie and get URL
      const selfieUrl = await submitPhotoFile();
      // const idFrontUrl = await submitIdFrontFile();
      // const idBackUrl = await submitIdBackFile();
      // const passporturl = await submitPassportFile();

      const payload = {
        firstname: firstName,
        middlename: middleName,
        lastname: lastName,
        identification: identification,
        identification_type: identificationType,
        // country_of_residence: country,
        dob: dob,
        username: username,
        citizenship: country,
        id_back_image: backFileUrl,
        id_front_image: frontFileUrl,
        passport_image: passportFileUrl,
        selfie_image: selfieUrl,
        gender,
        temporary_password: true,
        // status: "Pending Payment",
        onboarding_stage: "personal-information",
      };

      await updateCustomer(id, payload);

      // 2. Re-fetch updated customer (and await the actual data)
      await fetchCustomer(id);

      toast?.success("Personal information added successfully! 🎉");
      // await temporaryPassword({ email });
    } catch (error) {
      openReviewPanel();
      toast?.error(
        error?.message || "Error updating member and creating account:",
        {
          autoClose: false,
          closeOnClick: true,
          closeButton: true,
        },
      );
    }
  };

  const handleAdditionalAddressClick = async () => {
    const payload = {
      country_of_residence:
        countryOfResidence?.charAt(0)?.toUpperCase() +
        countryOfResidence?.slice(1)?.toLowerCase(),
      kraPin,
      occupation: jobTitle,
      income_range: monthlyIncome,
      citizenship: country,
      employment_type,
      onboarding_stage: "nextOfKin",
    };

    try {
      await updateCustomer(id, payload);
      await getAddressInfo({
        customer_id: id || customer?.id,
        county,
        subcounty: subCounty,
        physical_address: physicalAddress,
      });

      const updatedCustomer = await fetchCustomer(id);
      if (updatedCustomer?.status?.toLowerCase() === "active") {
        const updatedAccounts = await fetchCustomerAccounts(id);
        await ensureSharesAndSavingsAccounts(updatedAccounts, id);
      }
      toast?.success("Additional information added successfully! 🎉");
    } catch (error) {
      toast?.error(
        error?.message ||
          "Error updating member and creating account:" ||
          error,
        {
          autoClose: false,
          closeOnClick: true,
          closeButton: true,
        },
      );
    }
  };

  const handlePersonalInformation = async () => {
    setLoading(true);

    try {
      if (id) {
        await handleCompleteClick();
      }
      fetchCustomer(id);
      setTimeout(() => {
        closeReviewPanel();
        setFirstName("");
        setLastName("");
        setMiddleName("");
        setIdentification("");
        setGender("");
        setDob("");
        setUsername("");
        setIdFrontImage("");
        setIdBackImage("");
        setPassportImage("");
        setPhotoFile("");
      }, 1000);
    } catch (error) {
      openReviewPanel();
      toast?.error(
        error?.message ||
          "Error in the complete registration process:" ||
          error,
        {
          autoClose: false,
          closeOnClick: true,
          closeButton: true,
        },
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAdditionalInfor = async () => {
    setLoading(true);
    try {
      if (id) {
        await handleAdditionalAddressClick();
      }
      fetchCustomer(id);
      setTimeout(() => {
        closeAdditionalInfoPanel();
        setKraPin("");
        setMonthlyIncome("");
        setJobTitle("");
        setEmploymentType("");
        setCountryOfResidence("");
        setCounty("");
        setSubCounty("");
        setPhysicalAddress("");
      }, 100);
    } catch (error) {
      toast?.error(
        error?.message ||
          "Error in the complete registration process:" ||
          error,
        {
          autoClose: false,
          closeOnClick: true,
          closeButton: true,
        },
      );
    } finally {
      setLoading(false);
    }
  };

  const [isAdditionalInfoPanelOpen, setIsAdditionalInfoPanelOpen] =
    useState(false);
  const [showAddInfoHint, setShowAddInfoHint] = useState(false);

  const openAdditionalInfoPanel = () => {
    setIsAdditionalInfoPanelOpen(true);
  };

  const closeAdditionalInfoPanel = () => {
    setIsAdditionalInfoPanelOpen(false);
  };

  return (
    <div>
      <div className="my-[10px] px-[20px]">
        <button
          onClick={handleBack}
          className="h-[40px] text-[#06B217] text-[16px] w-[100px] rounded flex items-center justify-center gap-[10px] px-[20px]"
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="12" height="12" rx="6" fill="#06B217" />
            <path
              d="M2.625 5.625H10.125C10.2245 5.625 10.3198 5.66451 10.3902 5.73484C10.4605 5.80516 10.5 5.90054 10.5 6C10.5 6.09946 10.4605 6.19484 10.3902 6.26517C10.3198 6.33549 10.2245 6.375 10.125 6.375H2.625C2.52554 6.375 2.43016 6.33549 2.35984 6.26517C2.28951 6.19484 2.25 6.09946 2.25 6C2.25 5.90054 2.28951 5.80516 2.35984 5.73484C2.43016 5.66451 2.52554 5.625 2.625 5.625Z"
              fill="white"
            />
            <path
              d="M2.78043 6.00047L5.89068 9.10997C5.9611 9.18039 6.00065 9.27589 6.00065 9.37547C6.00065 9.47505 5.9611 9.57056 5.89068 9.64097C5.82027 9.71139 5.72476 9.75095 5.62518 9.75095C5.5256 9.75095 5.4301 9.71139 5.35968 9.64097L1.98468 6.26597C1.94976 6.23114 1.92205 6.18976 1.90315 6.1442C1.88424 6.09864 1.87451 6.0498 1.87451 6.00047C1.87451 5.95115 1.88424 5.90231 1.90315 5.85675C1.92205 5.81119 1.94976 5.76981 1.98468 5.73497L5.35968 2.35997C5.4301 2.28956 5.5256 2.25 5.62518 2.25C5.72476 2.25 5.82027 2.28956 5.89068 2.35997C5.9611 2.43039 6.00065 2.52589 6.00065 2.62547C6.00065 2.72506 5.9611 2.82056 5.89068 2.89097L2.78043 6.00047Z"
              fill="white"
            />
          </svg>
          <span className="underline">Back</span>
        </button>
      </div>

      {(customer?.onboarding_stage === "registration" ||
        customer?.onboarding_stage === "personal-information" ||
        customer?.onboarding_stage === "nextOfKin") && (
        <div className="px-10">
          <p className="text-[20px] font-[600] text-[#000000]">
            Add A New Member
          </p>
          <p className="text-[#000000] text-[15px] font-[300]">
            Register a new member by filling out the sections below.
          </p>
        </div>
      )}

      <div className="h-[118px] bg-[#005C53] w-full flex items-center justify-between px-8 mt-2">
        <div className="flex items-center gap-[30px]">
          <div className="h-[80px] w-[80px] text-[24px] text-[#005C53] rounded-[100%] bg-[#F0FFFE] flex items-center justify-center">
            {customer?.firstname?.slice(0, 1)}
            {customer?.lastname?.slice(0, 1)}
          </div>
          <div className="flex flex-col">
            <p className="text-[#D3EAFF] text-[14px]">{customer?.public_id}</p>
            {(customer?.firstname || customer?.lastname) && (
              <p className="text-white text-[24px]">
                {[customer?.firstname, customer?.lastname]
                  ?.filter(Boolean)
                  ?.map(
                    (name) =>
                      name?.charAt(0)?.toUpperCase() +
                      name?.slice(1)?.toLowerCase(),
                  )
                  ?.join(" ")}
              </p>
            )}
            <p className="text-[#D3EAFF] text-[14px]">{customer?.username}</p>
          </div>
          <div className="w-auto h-[44px] px-3 rounded-[30px] bg-[#8ED6A8] flex justify-center items-center">
            <div className="flex items-center gap-[3px]">
              {customer?.status === "Active" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <g clip-path="url(#clip0_7769_947)">
                    <path
                      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
                      fill="#0C722F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7769_947">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              )}
              {customer?.status === "Incomplete" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  viewBox="0 0 9 9"
                  fill="none"
                >
                  <circle cx="4.5" cy="4.5" r="4.5" fill="#FAB32B" />
                </svg>
              )}
              {customer?.status === "Inactive" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                >
                  <g clip-path="url(#clip0_6917_381)">
                    <path
                      d="M6.5 12C9.81371 12 12.5 9.31371 12.5 6C12.5 2.68629 9.81371 0 6.5 0C3.18629 0 0.5 2.68629 0.5 6C0.5 9.31371 3.18629 12 6.5 12Z"
                      fill="#C4C4C4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6917_381">
                      <rect
                        width="12"
                        height="12"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              )}
              {customer?.status === "Pending Verification" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <g clip-path="url(#clip0_7769_947)">
                    <path
                      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
                      fill="#FFCB35"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7769_947">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              )}
              {customer?.status === "Pending Payment" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle cx="12" cy="12" r="10" fill="#FFCB35" />

                  <circle cx="12" cy="10" r="3" fill="white" />

                  <path
                    d="M7 18c0-2.5 2.5-4 5-4s5 1.5 5 4"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />

                  <circle
                    cx="18"
                    cy="18"
                    r="2.5"
                    fill="white"
                    stroke="#FFCB35"
                    strokeWidth="1.5"
                  />
                </svg>
              )}
              <p className="text-[#005C53] text-[12px] ml-2">
                {customer?.status === "Pending Verification" &&
                customer?.onboarding_stage !== "completed"
                  ? "Incomplete"
                  : customer?.status}
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[10px]">
          <PermissionGate required={[PERMISSIONS?.MB?.UNSUSPEND_MEMBER]}>
            {customer && customer?.suspended === true && (
              <div
                onClick={openUnsuspendMember}
                className="w-[194px] h-[31px] cursor-pointer bg-[rgba(255,255,255,0.06)] gap-[10px] rounded-[40px] flex items-center p-[10px]"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_16286_2852)">
                    <path
                      d="M14.1667 8.33333V6.66667C14.1667 4.9058 12.7609 3.5 11 3.5C9.23913 3.5 7.83333 4.9058 7.83333 6.66667V8.33333M4.16667 8.33333H15.8333C16.7538 8.33333 17.5 9.07953 17.5 10V17.5C17.5 18.4205 16.7538 19.1667 15.8333 19.1667H4.16667C3.24619 19.1667 2.5 18.4205 2.5 17.5V10C2.5 9.07953 3.24619 8.33333 4.16667 8.33333Z"
                      stroke="#19C1E4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_16286_2852">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <p className="text-white text-[14px]">Unsuspend Member</p>
              </div>
            )}
          </PermissionGate>
          <PermissionGate required={[PERMISSIONS?.MB?.RESET_PASSWORD]}>
            {customer && customer?.suspended === false && (
              <div
                onClick={openCustomerResetPassword}
                className="w-[194px] h-[31px] cursor-pointer bg-[rgba(255,255,255,0.06)] gap-[10px] rounded-[40px] flex items-center p-[10px]"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_16286_2851)">
                    <path
                      d="M16.6665 11.3337V10.0003C16.6665 9.6467 16.526 9.30756 16.276 9.05752C16.0259 8.80747 15.6868 8.66699 15.3332 8.66699H1.99984C1.64622 8.66699 1.30708 8.80747 1.05703 9.05752C0.80698 9.30756 0.666504 9.6467 0.666504 10.0003V18.0003C0.666504 18.3539 0.80698 18.6931 1.05703 18.9431C1.30708 19.1932 1.64622 19.3337 1.99984 19.3337H15.3332C15.6868 19.3337 16.0259 19.1932 16.276 18.9431C16.526 18.6931 16.6665 18.3539 16.6665 18.0003V16.667M16.6665 11.3337H11.3332C10.6259 11.3337 9.94765 11.6146 9.44755 12.1147C8.94745 12.6148 8.6665 13.2931 8.6665 14.0003C8.6665 14.7076 8.94745 15.3858 9.44755 15.8859C9.94765 16.386 10.6259 16.667 11.3332 16.667H16.6665M16.6665 11.3337C17.3737 11.3337 18.052 11.6146 18.5521 12.1147C19.0522 12.6148 19.3332 13.2931 19.3332 14.0003C19.3332 14.7076 19.0522 15.3858 18.5521 15.8859C18.052 16.386 17.3737 16.667 16.6665 16.667M4.6665 8.66699V4.66699C4.6665 3.60613 5.08793 2.58871 5.83808 1.83856C6.58822 1.08842 7.60564 0.666992 8.6665 0.666992C9.72737 0.666992 10.7448 1.08842 11.4949 1.83856C12.2451 2.58871 12.6665 3.60613 12.6665 4.66699V8.66699M15.9998 14.0003H17.3332M13.3332 14.0003H14.6665M10.6665 14.0003H11.9998"
                      stroke="#19C1E4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_16286_2851">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p className="text-white text-[14px]">Reset Password</p>
              </div>
            )}
          </PermissionGate>
          <PermissionGate required={[PERMISSIONS?.MB?.DELETE_MEMBER]}>
            <div
              onClick={openDeleteAccountPop}
              className="w-[194px] h-[31px] cursor-pointer bg-[#FF5757] gap-[10px] rounded-[40px] flex items-center p-[10px]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5.83301 17.5C5.37467 17.5 4.98217 17.3367 4.65551 17.01C4.32884 16.6833 4.16579 16.2911 4.16634 15.8333V5H3.33301V3.33333H7.49967V2.5H12.4997V3.33333H16.6663V5H15.833V15.8333C15.833 16.2917 15.6697 16.6842 15.343 17.0108C15.0163 17.3375 14.6241 17.5006 14.1663 17.5H5.83301ZM7.49967 14.1667H9.16634V6.66667H7.49967V14.1667ZM10.833 14.1667H12.4997V6.66667H10.833V14.1667Z"
                  fill="white"
                />
              </svg>
              <p className="text-white text-[14px]">Delete Member</p>
            </div>
          </PermissionGate>
        </div>
      </div>
      {customer?.status === "Pending Verification" && (
        <div className="flex justify-center items-center h-full mt-2">
          <div className="bg-[#FFF6DD] rounded-[3px]  w-[98%] px-[8px]">
            <div className="text-[#000000] text-[14px] font-normal mt-3">
              This member's account is under pending verification status due to
              the reason
            </div>

            <div>
              {pendingReasons?.map((item) => (
                <div
                  key={item?.id}
                  className="text-[#000000] text-[14px] font-normal mt-2"
                >
                  {item?.reason}{" "}
                  <span
                    className="text-[#06B217] font-semibold cursor-pointer"
                    onClick={handleOpenUploadedKYCModal}
                  >
                    REVIEW
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <UploadedKYCdocs
        id="firstModal"
        closeModalFunction={closeModal}
        isModalOpen={isModalOpen}
        firstName={customer?.firstname}
        lastName={customer?.lastname}
        middleName={customer?.middlename}
        gender={customer?.gender}
        identification={customer?.identification}
        dob={customer?.dob}
        handleOpenViewSelfiePhoto={handleOpenViewSelfiePhoto}
        handleOpenSeeIdentityDoc={handleOpenSeeIdentityDoc}
        handleOpenRejectionReason={handleOpenRejectionReason}
        handleOpenApprovalNote={handleOpenApprovalNote}
        setIsModalOpen={setIsModalOpen}
        setEditToApprove={setEditToApprove}
      />

      <EditToApprove
        editToApprove={editToApprove}
        closeEditToApprove={closeEditToApprove}
        setIsModalOpen={setIsModalOpen}
        handleOpenViewSelfiePhoto={handleOpenViewSelfiePhoto}
        handleOpenSeeIdentityDoc={handleOpenSeeIdentityDoc}
        customerEditDetails={customerEditDetails}
        setCustomerEditDetails={setCustomerEditDetails}
        handleOpenApprovalNote={handleOpenApprovalNote}
      />

      <SuccessApproveAccount
        successApproveAccountOpen={successApproveAccountOpen}
        handleCloseSuccessApproveAccount={handleCloseSuccessApproveAccount}
      />

      <RejectIdSuccess
        rejectIdSuccessOpen={rejectIdSuccessOpen}
        handleCloseRejectIdSuccess={handleCloseRejectIdSuccess}
      />

      <ViewSelfiePhoto
        viewSelfiePhotoOpen={viewSelfiePhotoOpen}
        document={customer?.selfie_image}
        handleCloseViewSelfiePhoto={handleCloseViewSelfiePhoto}
        setSelfiePhotoModalOpen={setSelfiePhotoModalOpen}
      />

      <SeeIdentityDoc
        seeIdentityDocOpen={seeIdentityDocOpen}
        document={customer}
        handleCloseSeeIdentityDoc={handleCloseSeeIdentityDoc}
        setUploadNewIDOpen={setUploadNewIDOpen}
      />

      <RejectionReason
        id="firstModal"
        rejectionReason={rejectionReason}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        handleCloseRejectionReason={handleCloseRejectionReason}
        setIsModalOpen={setIsModalOpen}
        handleOpenNoteToReject={handleOpenNoteToReject}
      />

      <UploadNewID
        id_R="uploadNewId"
        uploadNewIDOpen={uploadNewIDOpen}
        closeUploadNewIDModal={closeUploadNewIDModal}
        identificationType={identificationType}
        setIdentificationType={setIdentificationType}
        country={country}
        setCountry={setCountry}
        frontFile={frontFile}
        setFrontFile={setFrontFile}
        backFile={backFile}
        setBackFile={setBackFile}
        passportFile={passportFile}
        setPassportFile={setPassportFile}
        isContinueEnabled={isContinueEnabled}
        setIsContinueEnabled={setIsContinueEnabled}
        setIsContinueModalOpen={setIsContinueModalOpen}
        document={customer}
        uploadKenyaIdBack={uploadKenyaIdBack}
        uploadKenyaIdFront={uploadKenyaIdFront}
        uploadPassport={uploadPassport}
      />

      <NoteToReject
        id="firstModal"
        noteToReject={noteToReject}
        note={note}
        setNote={setNote}
        setRejectionReason={setRejectionReason}
        handleCloseNoteToReject={handleCloseNoteToReject}
        openRejectAccountApproval={openRejectAccountApproval}
      />

      <RejectAccountApproval
        isRejectAccountApprovalOpen={isRejectAccountApprovalOpen}
        closeRejectAccountApproval={closeRejectAccountApproval}
        handleRejectAccount={handleRejectAccount}
      />

      <ApprovalNote
        approvalNote={approvalNote}
        handleCloseApprovalNote={handleCloseApprovalNote}
        openAccountApproval={openAccountApproval}
      />

      <AccountApproval
        isAccountApprovalOpen={isAccountApprovalOpen}
        closeAccountApproval={closeAccountApproval}
        handleApproveAccount={handleApproveAccount}
      />

      <CustomerResetPassword
        id="id_R"
        isCustomerResetPasswordModalOpen={isCustomerResetPasswordModalOpen}
        closeCustomerResetPassword={closeCustomerResetPassword}
        handleAdminResetPassword={handleAdminResetPassword}
      />

      <PasswordResetLink
        id="id_R"
        isPasswordResetLinkOpen={isPasswordResetLinkOpen}
        closePasswordResetLink={closePasswordResetLink}
        customer={customer}
      />

      <UnsuspendMember
        id="id_R"
        isUnsuspendMemberModalOpen={isUnsuspendMemberModalOpen}
        closeUnsuspendMember={closeUnsuspendMember}
        handleUnsuspendmember={handleUnsuspendmember}
      />

      <SuccessUnsuspendedMember
        id="id_R"
        isSuccessUnsuspendedMemberOpen={isSuccessUnsuspendedMemberOpen}
        closeSuccessUnsuspendedMember={closeSuccessUnsuspendedMember}
      />

      <SelectDocument
        id="id_R"
        isSelectDocumentOpen={isSelectDocumentOpen}
        closeSelectDoc={closeSelectDoc}
        docSelected={docSelected}
        setDocSelected={setDocSelected}
        ContinueSelectDoc={ContinueSelectDoc}
      />

      <FeePayment
        id="id_R"
        isFeePaymentOpen={isFeePaymentOpen}
        closeFeePayment={closeFeePayment}
        mpesaNumber={mpesaNumber}
        setMpesaNumber={setMpesaNumber}
        customer={customer}
        handleRegisterShares={handleRegisterShares}
        joiningFee={joiningFee}
        setJoiningFee={setJoiningFee}
        savingsAmount={savingsAmount}
        setSavingsAmount={setSavingsAmount}
        sharesAmount={sharesAmount}
        setSharesAmount={setSharesAmount}
      />

      <div className="w-full bg-white flex flex-col md:flex-row px-5 py-5 gap-5 md:gap-5 items-start">
        <div className="flex flex-col w-full md:w-[50%] gap-5 mb-10">
          <div
            className="w-full rounded-lg p-3"
            style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
          >
            {showDetails && (
              <div className="flex flex-col gap-4  w-full">
                <div className="flex mb-2 items-center justify-between">
                  <p className="text-[16px] text-[#005C53]">
                    Personal Information
                  </p>

                  <PermissionGate required={[PERMISSIONS?.MB?.EDIT_INFO]}>
                    <div
                      onClick={handleOpenEditCustomerPersonalInfo}
                      className="w-[78px] border-[#005C53] border-[1px] h-[31px] cursor-pointer rounded-[40px] bg-white flex justify-center items-center gap-[5px]"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M7 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17"
                          stroke="#005C53"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16 5.00011L19 8.00011M20.385 6.58511C20.7788 6.19126 21.0001 5.65709 21.0001 5.10011C21.0001 4.54312 20.7788 4.00895 20.385 3.61511C19.9912 3.22126 19.457 3 18.9 3C18.343 3 17.8088 3.22126 17.415 3.61511L9 12.0001V15.0001H12L20.385 6.58511Z"
                          stroke="#005C53"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <p className="text-[12px] text-[#005C53]">Edit</p>
                    </div>
                  </PermissionGate>
                </div>
                <div className="w-[96%] flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">First Name</p>
                    <p className="text-[#000]">{customer?.firstname}</p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Last Name</p>
                    <p>{customer?.lastname}</p>
                  </div>
                </div>
                <div className="w-[96%] flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Email Address</p>
                    <p>{customer?.email}</p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Phone Number</p>
                    <p>{customer?.mobileno}</p>
                  </div>
                </div>
                <div className="w-[96%] flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Date of Birth</p>
                    <p>
                      {customer?.dob
                        ? new Date(customer?.dob)?.toISOString()?.split("T")[0]
                        : ""}
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Username</p>
                    <p>{customer?.username}</p>
                  </div>
                </div>
                <div className="w-[96%] flex items-center  mb-2">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Citizenship</p>
                    <p className="">{customer?.citizenship}</p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">
                      Member National ID Number
                    </p>
                    <p>{customer?.identification}</p>
                  </div>
                </div>
              </div>
            )}
            {showEmptyState && (
              <div className="flex flex-col gap-4 w-full">
                <div className="flex mb-2 items-center justify-between">
                  <p className="text-[16px] text-[#005C53]">
                    Personal information
                  </p>
                </div>

                <div className="flex justify-center items-center h-[200px]">
                  <button
                    onClick={openIdentityPanel}
                    className="bg-[#005C53] text-white px-6 py-3 rounded"
                  >
                    Add Personal Details
                  </button>
                </div>
              </div>
            )}
          </div>
          <div
            className="w-full rounded-lg p-3"
            style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
          >
            <div className="flex mb-5 items-center justify-between">
              <p className="text-[16px] text-[#005C53]">
                Additional Information
              </p>
              {showAdditionalInfoEdit && (
                <PermissionGate required={[PERMISSIONS?.MB?.EDIT_INFO]}>
                  <div
                    onClick={handleOpenEditAdditionalInfo}
                    className="w-[78px] border-[#005C53] cursor-pointer border-[1px] h-[31px] rounded-[40px] bg-white flex justify-center items-center gap-[5px]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M7 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17"
                        stroke="#005C53"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 5.00011L19 8.00011M20.385 6.58511C20.7788 6.19126 21.0001 5.65709 21.0001 5.10011C21.0001 4.54312 20.7788 4.00895 20.385 3.61511C19.9912 3.22126 19.457 3 18.9 3C18.343 3 17.8088 3.22126 17.415 3.61511L9 12.0001V15.0001H12L20.385 6.58511Z"
                        stroke="#005C53"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="text-[12px] text-[#005C53]">Edit</p>
                  </div>
                </PermissionGate>
              )}
            </div>

            {isRegistration && !hasAdditionalInfo ? (
              <div className="flex flex-col gap-4 w-full">
                <div className="flex flex-col justify-center items-center h-[200px]">
                  <button
                    onClick={() => {
                      if (!isAdditionalInfoEnabled) {
                        setShowAddInfoHint(true);
                        return;
                      }

                      setShowAddInfoHint(false);
                      openAdditionalInfoPanel();
                    }}
                    onMouseLeave={() => setShowAddInfoHint(false)}
                    //  onMouseLeave={() =>
                    //   setTimeout(() => setShowAddInfoHint(false), 150)
                    // }// 👈 hide on mouse leave
                    onBlur={() => setShowAddInfoHint(false)} // 👈 hide on keyboard blur
                    className={`text-white px-6 py-3 rounded ${
                      isAdditionalInfoEnabled
                        ? "bg-[#005C53]"
                        : "bg-[#9F9F9F] cursor-not-allowed"
                    }`}
                  >
                    Add Additional Information
                  </button>

                  {showAddInfoHint && !isAdditionalInfoEnabled && (
                    <p className="text-sm text-red-500 text-center mt-2">
                      Please complete personal details first
                    </p>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="w-[96%] mb-5 flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">KRA PIN</p>
                    <p className="">{customer?.kraPin || customer?.ssn}</p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Monthly Income</p>
                    <p>
                      KES &nbsp;
                      {Number(customer?.income_range || "0.00")?.toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        },
                      )}
                    </p>
                  </div>
                </div>
                <div className="w-[96%] mb-5 flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Employment Type</p>
                    <p className="">{customer?.employment_type}</p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Job Title</p>
                    <p className="">{customer?.occupation}</p>
                  </div>
                </div>
                <div className="w-[96%] mb-5 flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Country</p>
                    <p className="">
                      {customer?.country_of_residence
                        ? customer?.country_of_residence
                        : ""}
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">County</p>
                    <p>
                      {customer?.addresses?.length > 0
                        ? customer?.addresses[0]?.county ||
                          customer?.addresses[0]?.town ||
                          ""
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="w-[96%] flex items-center mb-2">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Sub-county</p>
                    <p className="">
                      {customer?.addresses?.length > 0
                        ? customer?.addresses[0]?.subcounty ||
                          customer?.addresses[0]?.street ||
                          ""
                        : ""}
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">
                      Physical Address
                    </p>
                    <p>
                      {customer?.addresses?.length > 0
                        ? customer.addresses[0]?.physical_address || ""
                        : ""}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>

          <div
            className="w-full rounded-lg p-3"
            style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
          >
            <div className="flex mb-5 items-center justify-between">
              <p className="text-[16px] text-[#005C53]">
                Next of KIN information
              </p>
              {showNextofkinEdit && (
                <PermissionGate required={[PERMISSIONS?.MB?.EDIT_INFO]}>
                  <div
                    onClick={handleOpenEditNextOfKin}
                    className="w-[78px] border-[#005C53] cursor-pointer border-[1px] h-[31px] rounded-[40px] bg-white flex justify-center items-center gap-[5px]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M7 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17"
                        stroke="#005C53"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 5.00011L19 8.00011M20.385 6.58511C20.7788 6.19126 21.0001 5.65709 21.0001 5.10011C21.0001 4.54312 20.7788 4.00895 20.385 3.61511C19.9912 3.22126 19.457 3 18.9 3C18.343 3 17.8088 3.22126 17.415 3.61511L9 12.0001V15.0001H12L20.385 6.58511Z"
                        stroke="#005C53"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="text-[12px] text-[#005C53]">Edit</p>
                  </div>
                </PermissionGate>
              )}
            </div>

            {(customer?.onboarding_stage === "registration" ||
              customer?.onboarding_stage === "personal-information" ||
              customer?.onboarding_stage === "nextOfKin") &&
            !hasNextOfKin ? (
              <div className="flex flex-col gap-4 w-full">
                <div className="flex flex-col justify-center items-center h-[200px]">
                  <button
                    onClick={() => {
                      if (!isNextOfKinEnabled) {
                        setShowNextOfKinHint(true);
                        return;
                      }

                      setShowNextOfKinHint(false);
                      openNextOfKinPanel();
                    }}
                    onMouseLeave={() => setShowNextOfKinHint(false)} // 👈 hide on cursor leave
                    onBlur={() => setShowNextOfKinHint(false)} // 👈 hide on keyboard focus leave
                    className={`text-white px-6 py-3 rounded ${
                      isNextOfKinEnabled
                        ? "bg-[#005C53]"
                        : "bg-[#9F9F9F] cursor-not-allowed"
                    }`}
                  >
                    Add Next of Kin
                  </button>

                  {showNextOfKinHint && !isNextOfKinEnabled && (
                    <p className="text-sm text-red-500 text-center mt-2">
                      {getNextOfKinError()}
                    </p>
                  )}
                </div>
              </div>
            ) : customer?.nextOfKins && customer?.nextOfKins?.length > 0 ? (
              /* ✅ DATA STATE */
              <div>
                <div className="w-[96%] mb-5 flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Full Name</p>
                    <p className="">
                      {customer?.nextOfKins?.length > 0
                        ? customer.nextOfKins[0]?.name
                        : ""}
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Date of Birth</p>
                    <p>
                      {customer?.nextOfKins?.length > 0
                        ? customer.nextOfKins[0]?.dateOfBirth
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="w-[96%] mb-5 flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Relationship</p>
                    <p className="">
                      {customer?.nextOfKins?.length > 0
                        ? customer.nextOfKins[0]?.relationship
                        : ""}
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-gray-400 text-[14px]">Phone number</p>
                    <p className="">
                      {customer?.nextOfKins?.length > 0
                        ? customer.nextOfKins[0]?.phoneNumber
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="w-[96%] mb-3 flex items-center">
                  <div className="w-[80%]">
                    <p className="text-gray-400 text-[14px]">Location</p>
                    <p className="">
                      {customer?.nextOfKins?.length > 0
                        ? customer.nextOfKins[0]?.location
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <p>You don't have next of kin</p>
            )}
          </div>
          <div
            className="w-full rounded-lg p-3"
            style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
          >
            <div className="flex mb-5 items-center justify-between">
              <p className="text-[16px] text-[#005C53]">Documents</p>
            </div>
            {((customer?.id_back_image && customer?.id_front_image) ||
              customer?.passport_image) &&
              customer?.selfie_image && (
                <div>
                  <div className="flex mb-5 items-center justify-between">
                    <p className="text-[16px]">
                      {customer?.firstname} {customer?.lastname}
                    </p>
                  </div>
                  <div className="w-[90%] mb-5 flex items-center">
                    <div className="w-[70%]">
                      <p className="text-[14px]">DATE UPLOADED</p>
                    </div>
                    <div className="w-[55%]">
                      <p className="text-[14px]">DOCUMENT TYPE</p>
                    </div>
                    <div className="w-[40%] flex justify-center">
                      <p className="text-[14px]">VIEW</p>
                    </div>
                  </div>
                  <div className="w-[90%] mb-5 flex items-center">
                    <div className="w-[70%]">
                      <p className="text-[14px]">
                        {customer?.createdAt
                          ? formatDateTime(customer.createdAt)
                          : ""}
                      </p>
                    </div>
                    <div className="w-[55%]">
                      <p className="text-[14px] text-[#06B217]">
                        {customer?.identification_type
                          ? customer?.identification_type
                          : ""}
                      </p>
                    </div>
                    <div className="w-[40%] flex justify-center">
                      <div
                        onClick={() => handleViewID()}
                        className="w-[78px] cursor-pointer h-[31px] bg-white flex justify-center items-center gap-[1px]"
                      >
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.8377 9.7875C19.1026 7.88603 17.8265 6.24164 16.167 5.05755C14.5075 3.87347 12.5374 3.20161 10.5002 3.125C8.46305 3.20161 6.49296 3.87347 4.83347 5.05755C3.17398 6.24164 1.89782 7.88603 1.16272 9.7875C1.11308 9.92482 1.11308 10.0752 1.16272 10.2125C1.89782 12.114 3.17398 13.7584 4.83347 14.9424C6.49296 16.1265 8.46305 16.7984 10.5002 16.875C12.5374 16.7984 14.5075 16.1265 16.167 14.9424C17.8265 13.7584 19.1026 12.114 19.8377 10.2125C19.8874 10.0752 19.8874 9.92482 19.8377 9.7875ZM10.5002 15.625C7.18772 15.625 3.68772 13.1687 2.41897 10C3.68772 6.83125 7.18772 4.375 10.5002 4.375C13.8127 4.375 17.3127 6.83125 18.5815 10C17.3127 13.1687 13.8127 15.625 10.5002 15.625Z"
                            fill="black"
                          />
                          <path
                            d="M10.5 6.25C9.75832 6.25 9.0333 6.46993 8.41661 6.88199C7.79993 7.29404 7.31928 7.87971 7.03545 8.56494C6.75162 9.25016 6.67736 10.0042 6.82206 10.7316C6.96675 11.459 7.3239 12.1272 7.84835 12.6517C8.3728 13.1761 9.04098 13.5333 9.76841 13.6779C10.4958 13.8226 11.2498 13.7484 11.9351 13.4645C12.6203 13.1807 13.206 12.7001 13.618 12.0834C14.0301 11.4667 14.25 10.7417 14.25 10C14.25 9.00544 13.8549 8.05161 13.1517 7.34835C12.4484 6.64509 11.4946 6.25 10.5 6.25ZM10.5 12.5C10.0055 12.5 9.5222 12.3534 9.11108 12.0787C8.69995 11.804 8.37952 11.4135 8.1903 10.9567C8.00108 10.4999 7.95158 9.99723 8.04804 9.51227C8.1445 9.02732 8.3826 8.58186 8.73223 8.23223C9.08187 7.8826 9.52732 7.6445 10.0123 7.54804C10.4972 7.45157 10.9999 7.50108 11.4567 7.6903C11.9135 7.87952 12.304 8.19995 12.5787 8.61107C12.8534 9.0222 13 9.50555 13 10C13 10.663 12.7366 11.2989 12.2678 11.7678C11.7989 12.2366 11.163 12.5 10.5 12.5Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  {customer?.documents?.length > 0 &&
                    customer?.documents?.map((document, index) => (
                      <div
                        key={index}
                        className="w-[90%] mb-5 flex items-center"
                      >
                        <div className="w-[70%]">
                          <p className="text-[14px]">
                            {formatDateTime(document?.dateUploaded) || ""}
                          </p>
                        </div>
                        <div className="w-[55%]">
                          <p className="text-[14px] text-[#06B217]">
                            {document?.type}
                          </p>
                        </div>
                        <div className="w-[40%] flex justify-center">
                          <div
                            onClick={() => handleViewCustomerDocument(document)}
                            className="w-[78px] cursor-pointer h-[31px] bg-white flex justify-center items-center gap-[1px]"
                          >
                            <svg
                              width="21"
                              height="20"
                              viewBox="0 0 21 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.8377 9.7875C19.1026 7.88603 17.8265 6.24164 16.167 5.05755C14.5075 3.87347 12.5374 3.20161 10.5002 3.125C8.46305 3.20161 6.49296 3.87347 4.83347 5.05755C3.17398 6.24164 1.89782 7.88603 1.16272 9.7875C1.11308 9.92482 1.11308 10.0752 1.16272 10.2125C1.89782 12.114 3.17398 13.7584 4.83347 14.9424C6.49296 16.1265 8.46305 16.7984 10.5002 16.875C12.5374 16.7984 14.5075 16.1265 16.167 14.9424C17.8265 13.7584 19.1026 12.114 19.8377 10.2125C19.8874 10.0752 19.8874 9.92482 19.8377 9.7875ZM10.5002 15.625C7.18772 15.625 3.68772 13.1687 2.41897 10C3.68772 6.83125 7.18772 4.375 10.5002 4.375C13.8127 4.375 17.3127 6.83125 18.5815 10C17.3127 13.1687 13.8127 15.625 10.5002 15.625Z"
                                fill="black"
                              />
                              <path
                                d="M10.5 6.25C9.75832 6.25 9.0333 6.46993 8.41661 6.88199C7.79993 7.29404 7.31928 7.87971 7.03545 8.56494C6.75162 9.25016 6.67736 10.0042 6.82206 10.7316C6.96675 11.459 7.3239 12.1272 7.84835 12.6517C8.3728 13.1761 9.04098 13.5333 9.76841 13.6779C10.4958 13.8226 11.2498 13.7484 11.9351 13.4645C12.6203 13.1807 13.206 12.7001 13.618 12.0834C14.0301 11.4667 14.25 10.7417 14.25 10C14.25 9.00544 13.8549 8.05161 13.1517 7.34835C12.4484 6.64509 11.4946 6.25 10.5 6.25ZM10.5 12.5C10.0055 12.5 9.5222 12.3534 9.11108 12.0787C8.69995 11.804 8.37952 11.4135 8.1903 10.9567C8.00108 10.4999 7.95158 9.99723 8.04804 9.51227C8.1445 9.02732 8.3826 8.58186 8.73223 8.23223C9.08187 7.8826 9.52732 7.6445 10.0123 7.54804C10.4972 7.45157 10.9999 7.50108 11.4567 7.6903C11.9135 7.87952 12.304 8.19995 12.5787 8.61107C12.8534 9.0222 13 9.50555 13 10C13 10.663 12.7366 11.2989 12.2678 11.7678C11.7989 12.2366 11.163 12.5 10.5 12.5Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}

            {!customer?.passport_image &&
              (!customer?.id_front_image || !customer?.id_back_image) &&
              !customer?.selfie_image && (
                <div className="flex-col flex justify-center items-center mb-3">
                  <div className="mt-5 text-[14px] text-[#060606] text-center">
                    No KYC documents found for this user. <br /> Once documents
                    are uploaded or assigned, they’ll <br /> appear here.
                  </div>

                  <button
                    onClick={() => setIsSelectDocumentOpen(true)}
                    className="flex mt-5 justify-center items-center cursor-pointer px-3 py-3 rounded-[5px] bg-[#005C53]"
                  >
                    <p className="text-[16px] font-[500] text-[#FFFFFF]">
                      Upload Missing KYC Documents
                    </p>
                  </button>
                </div>
              )}

            {((customer?.id_back_image && customer?.id_front_image) ||
              customer?.passport_image) &&
              !customer?.selfie_image && (
                <div className="flex-col flex justify-center items-center mb-3">
                  <div className="w-[95%] mb-5 flex items-center">
                    <div className="w-[70%]">
                      <p className="text-[14px]">DATE UPLOADED</p>
                    </div>
                    <div className="w-[55%]">
                      <p className="text-[14px]">DOCUMENT TYPE</p>
                    </div>
                    <div className="w-[40%] flex justify-center">
                      <p className="text-[14px]">VIEW</p>
                    </div>
                  </div>
                  <div className="w-[95%] mb-5 flex items-center">
                    <div className="w-[70%]">
                      <p className="text-[14px]">
                        {customer?.createdAt
                          ? formatDateTime(customer?.createdAt)
                          : ""}
                      </p>
                    </div>
                    <div className="w-[55%]">
                      <p className="text-[14px] text-[#06B217]">
                        {customer?.identification_type
                          ? customer?.identification_type
                          : ""}
                      </p>
                    </div>
                    <div className="w-[40%] flex justify-center">
                      <div
                        onClick={() => handleViewID()}
                        className="w-[78px] cursor-pointer h-[31px] bg-white flex justify-center items-center gap-[1px]"
                      >
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.8377 9.7875C19.1026 7.88603 17.8265 6.24164 16.167 5.05755C14.5075 3.87347 12.5374 3.20161 10.5002 3.125C8.46305 3.20161 6.49296 3.87347 4.83347 5.05755C3.17398 6.24164 1.89782 7.88603 1.16272 9.7875C1.11308 9.92482 1.11308 10.0752 1.16272 10.2125C1.89782 12.114 3.17398 13.7584 4.83347 14.9424C6.49296 16.1265 8.46305 16.7984 10.5002 16.875C12.5374 16.7984 14.5075 16.1265 16.167 14.9424C17.8265 13.7584 19.1026 12.114 19.8377 10.2125C19.8874 10.0752 19.8874 9.92482 19.8377 9.7875ZM10.5002 15.625C7.18772 15.625 3.68772 13.1687 2.41897 10C3.68772 6.83125 7.18772 4.375 10.5002 4.375C13.8127 4.375 17.3127 6.83125 18.5815 10C17.3127 13.1687 13.8127 15.625 10.5002 15.625Z"
                            fill="black"
                          />
                          <path
                            d="M10.5 6.25C9.75832 6.25 9.0333 6.46993 8.41661 6.88199C7.79993 7.29404 7.31928 7.87971 7.03545 8.56494C6.75162 9.25016 6.67736 10.0042 6.82206 10.7316C6.96675 11.459 7.3239 12.1272 7.84835 12.6517C8.3728 13.1761 9.04098 13.5333 9.76841 13.6779C10.4958 13.8226 11.2498 13.7484 11.9351 13.4645C12.6203 13.1807 13.206 12.7001 13.618 12.0834C14.0301 11.4667 14.25 10.7417 14.25 10C14.25 9.00544 13.8549 8.05161 13.1517 7.34835C12.4484 6.64509 11.4946 6.25 10.5 6.25ZM10.5 12.5C10.0055 12.5 9.5222 12.3534 9.11108 12.0787C8.69995 11.804 8.37952 11.4135 8.1903 10.9567C8.00108 10.4999 7.95158 9.99723 8.04804 9.51227C8.1445 9.02732 8.3826 8.58186 8.73223 8.23223C9.08187 7.8826 9.52732 7.6445 10.0123 7.54804C10.4972 7.45157 10.9999 7.50108 11.4567 7.6903C11.9135 7.87952 12.304 8.19995 12.5787 8.61107C12.8534 9.0222 13 9.50555 13 10C13 10.663 12.7366 11.2989 12.2678 11.7678C11.7989 12.2366 11.163 12.5 10.5 12.5Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => setIsSelfieModalOpen(true)}
                    className="flex mt-5 justify-center items-center cursor-pointer px-10 py-3 rounded-[5px] bg-[#005C53]"
                  >
                    <p className="text-[16px] font-[500] text-[#FFFFFF]">
                      Upload Selfie
                    </p>
                  </button>
                </div>
              )}

            {!customer?.passport_image &&
              (!customer?.id_front_image || !customer?.id_back_image) &&
              customer?.selfie_image && (
                <div className="flex-col flex justify-center items-center mb-3">
                  <div className="w-[95%] mb-5 flex items-center">
                    <div className="w-[70%]">
                      <p className="text-[14px]">DATE UPLOADED</p>
                    </div>
                    <div className="w-[55%]">
                      <p className="text-[14px]">DOCUMENT TYPE</p>
                    </div>
                    <div className="w-[40%] flex justify-center">
                      <p className="text-[14px]">VIEW</p>
                    </div>
                  </div>
                  {customer?.documents?.length > 0 &&
                    customer?.documents?.map((document, index) => (
                      <div
                        key={index}
                        className="w-[95%] mb-5 flex items-center"
                      >
                        <div className="w-[70%]">
                          <p className="text-[14px]">
                            {formatDateTime(document?.dateUploaded) || ""}
                          </p>
                        </div>
                        <div className="w-[55%]">
                          <p className="text-[14px] text-[#06B217]">
                            {document?.type}
                          </p>
                        </div>
                        <div className="w-[40%] flex justify-center">
                          <div
                            onClick={() => handleViewCustomerDocument(document)}
                            className="w-[78px] cursor-pointer h-[31px] bg-white flex justify-center items-center gap-[1px]"
                          >
                            <svg
                              width="21"
                              height="20"
                              viewBox="0 0 21 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.8377 9.7875C19.1026 7.88603 17.8265 6.24164 16.167 5.05755C14.5075 3.87347 12.5374 3.20161 10.5002 3.125C8.46305 3.20161 6.49296 3.87347 4.83347 5.05755C3.17398 6.24164 1.89782 7.88603 1.16272 9.7875C1.11308 9.92482 1.11308 10.0752 1.16272 10.2125C1.89782 12.114 3.17398 13.7584 4.83347 14.9424C6.49296 16.1265 8.46305 16.7984 10.5002 16.875C12.5374 16.7984 14.5075 16.1265 16.167 14.9424C17.8265 13.7584 19.1026 12.114 19.8377 10.2125C19.8874 10.0752 19.8874 9.92482 19.8377 9.7875ZM10.5002 15.625C7.18772 15.625 3.68772 13.1687 2.41897 10C3.68772 6.83125 7.18772 4.375 10.5002 4.375C13.8127 4.375 17.3127 6.83125 18.5815 10C17.3127 13.1687 13.8127 15.625 10.5002 15.625Z"
                                fill="black"
                              />
                              <path
                                d="M10.5 6.25C9.75832 6.25 9.0333 6.46993 8.41661 6.88199C7.79993 7.29404 7.31928 7.87971 7.03545 8.56494C6.75162 9.25016 6.67736 10.0042 6.82206 10.7316C6.96675 11.459 7.3239 12.1272 7.84835 12.6517C8.3728 13.1761 9.04098 13.5333 9.76841 13.6779C10.4958 13.8226 11.2498 13.7484 11.9351 13.4645C12.6203 13.1807 13.206 12.7001 13.618 12.0834C14.0301 11.4667 14.25 10.7417 14.25 10C14.25 9.00544 13.8549 8.05161 13.1517 7.34835C12.4484 6.64509 11.4946 6.25 10.5 6.25ZM10.5 12.5C10.0055 12.5 9.5222 12.3534 9.11108 12.0787C8.69995 11.804 8.37952 11.4135 8.1903 10.9567C8.00108 10.4999 7.95158 9.99723 8.04804 9.51227C8.1445 9.02732 8.3826 8.58186 8.73223 8.23223C9.08187 7.8826 9.52732 7.6445 10.0123 7.54804C10.4972 7.45157 10.9999 7.50108 11.4567 7.6903C11.9135 7.87952 12.304 8.19995 12.5787 8.61107C12.8534 9.0222 13 9.50555 13 10C13 10.663 12.7366 11.2989 12.2678 11.7678C11.7989 12.2366 11.163 12.5 10.5 12.5Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}

                  <button
                    onClick={() => setIsIDModalOpen(true)}
                    className="flex mt-5 justify-center items-center cursor-pointer px-5 py-3 rounded-[5px] bg-[#005C53]"
                  >
                    <p className="text-[16px] font-[500] text-[#FFFFFF]">
                      Upload National ID
                    </p>
                  </button>
                </div>
              )}
          </div>

          {isCompletedAndActive && (
            <div
              className="w-full rounded-lg p-3"
              style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
            >
              <div className="flex mb-5 items-center justify-between">
                <p className="text-[16px] text-[#005C53]">
                  Guarantorship Status
                </p>
              </div>

              <div className="flex flex-col gap-6">
                {/* Total Amount Guaranteed */}
                <div className="flex items-center text-[14px]">
                  <p className="text-[#000000] w-[60%]">
                    Total Amount Guaranteed
                  </p>
                  <div className="flex items-center w-[40%] text-[#06B217]">
                    <span className="text-[13px] font-medium mr-1.5">KES</span>
                    <span className="text-[18px] font-semibold">
                      {Number(customer?.totalGuaranteed || 0).toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        },
                      )}
                    </span>
                  </div>
                </div>

                {/* Total Outstanding Exposure */}
                <div className="flex items-center text-[14px]">
                  <p className="text-[#000000] w-[60%]">
                    Total Outstanding Exposure
                  </p>
                  <div className="flex items-center w-[40%] text-[#06B217]">
                    <span className="text-[13px] font-medium mr-1.5">KES</span>
                    <span className="text-[18px] font-semibold">
                      {Number(
                        customer?.totalOutstandingExposure || 0,
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>

                {/* Available Guarantee Potential */}
                <div className="flex items-center text-[14px] mb-5">
                  <p className="text-[#000000] w-[60%]">
                    Available Guarantee Potential
                  </p>
                  <div className="flex items-center w-[40%] text-[#06B217]">
                    <span className="text-[13px] font-medium mr-1.5">KES</span>
                    <span className="text-[18px] font-semibold">
                      {Number(
                        customer?.availableGuaranteePotential || 0,
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {customer?.member && (
          <div
            className="w-full md:w-[49%] px-4 flex flex-col rounded-lg shadow-sm"
            style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
          >
            <div className="flex items-center mb-5 mt-5 w-full justify-between">
              <p className="text-[#005C53] text-[16px]">Accounts</p>
              <div className="flex items-center">
                <PermissionGate required={[PERMISSIONS?.MB?.CREATE_ACCOUNT]}>
                  <button className="bg-[#005C53] flex items-center gap-[10px] h-[44px] px-[10px] rounded-[5px]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                        fill="white"
                      />
                    </svg>
                    <p className="text-white text-[12px]">Create new account</p>
                  </button>
                </PermissionGate>
              </div>
            </div>
            {customerAccounts?.length > 0 &&
              customerAccounts?.map((account, index) => {
                const updatedBalance =
                  account?.product?.name === "Flash Loan"
                    ? flashLoan?.data?.loan_balance
                    : account?.product?.name === "Normal Loan"
                      ? normalLoan?.data?.loan_balance
                      : account?.product?.name === "Emergency Loan"
                        ? emergencyLoan?.data?.loan_balance
                        : account?.product?.name === "Development Loan"
                          ? developmentLoan?.data?.loan_balance
                          : account?.product?.name === "Jijenge Loan"
                            ? jijengeLoan?.data?.loan_balance
                            : account?.balance;

                const getAccountStatus = (account) => {
                  if (
                    account?.status === "active" &&
                    normalLoan &&
                    flashLoan &&
                    emergencyLoan &&
                    developmentLoan &&
                    jijengeLoan
                  ) {
                    if (account?.product?.name === "Normal Loan") {
                      return normalLoan?.data?.loan_status || account?.status;
                    } else if (account?.product?.name === "Flash Loan") {
                      return flashLoan?.data?.loan_status || account?.status;
                    } else if (account?.product?.name === "Emergency Loan") {
                      return (
                        emergencyLoan?.data?.loan_status || account?.status
                      );
                    } else if (account?.product?.name === "Development Loan") {
                      return (
                        developmentLoan?.data?.loan_status || account?.status
                      );
                    } else if (account?.product?.name === "Jijenge Loan") {
                      return jijengeLoan?.data?.loan_status || account?.status;
                    }
                  }
                  return account?.status;
                };
                return (
                  <div
                    onClick={() => {
                      let loanCode = "";
                      let prodId = "";

                      if (account?.product?.name === "Flash Loan") {
                        loanCode = flashLoan?.data?.loan_code;
                        prodId = "Flash_loan";
                      } else if (account?.product?.name === "Normal Loan") {
                        loanCode = normalLoan?.data?.loan_code;
                        prodId = "Guarantor_loan";
                      } else if (account?.product?.name === "Emergency Loan") {
                        loanCode = emergencyLoan?.data?.loan_code;
                        prodId = "Emergency_loan";
                      } else if (
                        account?.product?.name === "Development Loan"
                      ) {
                        loanCode = developmentLoan?.data?.loan_code;
                        prodId = "Development_loan";
                      } else if (account?.product?.name === "Jijenge Loan") {
                        loanCode = jijengeLoan?.data?.loan_code;
                        prodId = "Jijenge_loan";
                      }

                      navigateToTransactions(
                        customer?.id,
                        account?.id,
                        account?.account_number,
                        colors[index],
                        loanCode,
                        prodId,
                      );
                    }}
                    style={{ backgroundColor: `${colors[index]}` }}
                    className="bg-image-1 h-[165px] mb-5 cursor-pointer rounded-lg w-[100%] px-3 py-3"
                  >
                    <div className="w-full flex items-center justify-between">
                      <p className="text-[#FFFFFFB2] text-[12px]">
                        Account Type
                      </p>
                      <p className="text-[#FFFFFFB2] text-[12px]">
                        Account Number
                      </p>
                    </div>
                    <div className="w-full flex items-center justify-between">
                      <p className="text-[#FFFFFF] text-[20px]">
                        {account?.product?.name}
                      </p>
                      <p className="text-[#FFFFFF] text-[20px]">
                        {account?.account_number}
                      </p>
                    </div>
                    <div>
                      <p className="text-[#FFFFFFB2] text-[12px]">
                        Account Balance
                      </p>
                    </div>
                    <div className="flex items-center justify-between w-full">
                      <div className="flex items-center gap-[5px]">
                        <p className="text-white">KES</p>
                        <p
                          className={showBalance[account.id] ? `blur` : ""}
                          style={{ color: "white", fontSize: "16px" }}
                        >
                          <span className="text-[36px] text-white font-bold">
                            {Number(updatedBalance || "0.00")?.toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="bg-[#D3EAFF] w-[28px] h-[20px] rounded-[60%] flex items-center justify-center">
                        {showBalance[account?.id] ? (
                          <svg
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleBalanceVisibility(account?.id);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <g
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            >
                              <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0" />
                              <path d="M21 12c-2.4 4-5.4 6-9 6c-3.6 0-6.6-2-9-6c2.4-4 5.4-6 9-6c3.6 0 6.6 2 9 6" />
                            </g>
                          </svg>
                        ) : (
                          <svg
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleBalanceVisibility(account?.id);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="-2 -2 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="m15.398 7.23l1.472-1.472C18.749 6.842 20 8.34 20 10c0 3.314-4.958 5.993-10 6a14.734 14.734 0 0 1-3.053-.32l1.747-1.746c.426.044.862.067 1.303.066h.002c-.415 0-.815-.063-1.191-.18l1.981-1.982c.47-.202.847-.579 1.05-1.049l1.98-1.981A4 4 0 0 1 10.022 14C14.267 13.985 18 11.816 18 10c0-.943-1.022-1.986-2.602-2.77m-9.302 3.645A4 4 0 0 1 9.993 6C5.775 5.985 2 8.178 2 10c0 .896.904 1.877 2.327 2.644L2.869 14.1C1.134 13.028 0 11.585 0 10c0-3.314 4.984-6.017 10-6c.914.003 1.827.094 2.709.262l-1.777 1.776c-.29-.022-.584-.035-.88-.038c.282.004.557.037.823.096l-4.78 4.779zM19.092.707a1 1 0 0 1 0 1.414l-16.97 16.97a1 1 0 1 1-1.415-1.413L17.677.708a1 1 0 0 1 1.415 0z"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-[10px] justify-end w-full">
                      {getAccountStatus(account)?.toLowerCase() ===
                        "active" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="9"
                          viewBox="0 0 9 9"
                          fill="none"
                        >
                          <circle cx="4.5" cy="4.5" r="4.5" fill="#42F980" />
                        </svg>
                      )}
                      {getAccountStatus(account)?.toLowerCase() ===
                        "Incomplete" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="9"
                          viewBox="0 0 9 9"
                          fill="none"
                        >
                          <circle cx="4.5" cy="4.5" r="4.5" fill="#FAB32B" />
                        </svg>
                      )}
                      {getAccountStatus(account)?.toLowerCase() ===
                        "closed" && (
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.28125 7.72476V3.85938V7.72476ZM13.5625 7C13.5625 8.66589 12.9007 10.2636 11.7228 11.4415C10.5448 12.6195 8.94714 13.2812 7.28125 13.2812C5.61536 13.2812 4.0177 12.6195 2.83974 11.4415C1.66177 10.2636 1 8.66589 1 7C1 5.33411 1.66177 3.73645 2.83974 2.55849C4.0177 1.38052 5.61536 0.71875 7.28125 0.71875C8.94714 0.71875 10.5448 1.38052 11.7228 2.55849C12.9007 3.73645 13.5625 5.33411 13.5625 7Z"
                            fill="#FF5757"
                          />
                          <path
                            d="M7.28125 7.72476V3.85937M13.5625 7C13.5625 8.66589 12.9007 10.2636 11.7228 11.4415C10.5448 12.6195 8.94714 13.2812 7.28125 13.2812C5.61536 13.2812 4.0177 12.6195 2.83974 11.4415C1.66177 10.2636 1 8.66589 1 7C1 5.33411 1.66177 3.73645 2.83974 2.55849C4.0177 1.38052 5.61536 0.71875 7.28125 0.71875C8.94714 0.71875 10.5448 1.38052 11.7228 2.55849C12.9007 3.73645 13.5625 5.33411 13.5625 7Z"
                            stroke="white"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.7642 9.89894C7.7642 10.0271 7.71329 10.15 7.62268 10.2406C7.53207 10.3312 7.40917 10.3821 7.28102 10.3821C7.15288 10.3821 7.02998 10.3312 6.93937 10.2406C6.84876 10.15 6.79785 10.0271 6.79785 9.89894C6.79785 9.7708 6.84876 9.6479 6.93937 9.55729C7.02998 9.46668 7.15288 9.41577 7.28102 9.41577C7.40917 9.41577 7.53207 9.46668 7.62268 9.55729C7.71329 9.6479 7.7642 9.7708 7.7642 9.89894Z"
                            fill="#FF5757"
                            stroke="white"
                          />
                        </svg>
                      )}
                      {getAccountStatus(account)?.toLowerCase() ===
                        "suspended" && (
                        <svg
                          width="16"
                          height="13"
                          viewBox="0 0 16 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.35259 12.7498H13.6476C14.8026 12.7498 15.5226 11.4973 14.9451 10.4998L9.29759 0.742266C8.72009 -0.255234 7.28009 -0.255234 6.70259 0.742266L1.05509 10.4998C0.477591 11.4973 1.19759 12.7498 2.35259 12.7498ZM8.00009 7.49977C7.58759 7.49977 7.25009 7.16227 7.25009 6.74977V5.24977C7.25009 4.83727 7.58759 4.49977 8.00009 4.49977C8.41259 4.49977 8.75009 4.83727 8.75009 5.24977V6.74977C8.75009 7.16227 8.41259 7.49977 8.00009 7.49977ZM8.75009 10.4998H7.25009V8.99977H8.75009V10.4998Z"
                            fill="#FAB32B"
                          />
                        </svg>
                      )}

                      {getAccountStatus(account)?.toLowerCase() ===
                        "pending" && (
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                            fill="#FFCB35"
                          />
                        </svg>
                      )}

                      {getAccountStatus(account)?.toLowerCase() ===
                        "pending approval" && (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                            fill="#FFCB35"
                          />
                        </svg>
                      )}
                      {getAccountStatus(account)?.toLowerCase() ===
                        "approved" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_8496_1672)">
                            <path
                              d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
                              fill="#0C722F"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_8496_1672">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                      <p className="text-white text-[14px]">
                        {getAccountStatus(account)?.charAt(0)?.toUpperCase() +
                          getAccountStatus(account)?.slice(1)?.toLowerCase()}
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>
        )}

        {customer?.member === false &&
          customer?.onboarding_stage?.toLowerCase() === "completed" &&
          customer?.status?.toLowerCase() !== "pending verification" &&
          hasSharesAccount &&
          hasSavingsAccount && (
            <div
              className="w-full md:w-[49%] px-3 py-5 flex flex-col rounded-lg shadow-sm"
              style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
            >
              <div className="px-5 mb-32 flex flex-col rounded-[10px] bg-[#005C53]">
                <div className="mt-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="22.5"
                      cy="22.5"
                      r="22.5"
                      fill="white"
                      fill-opacity="0.44"
                    />
                    <path
                      d="M15.5 17C15.5 16.606 15.5776 16.2159 15.7284 15.8519C15.8791 15.488 16.1001 15.1573 16.3787 14.8787C16.6573 14.6001 16.988 14.3791 17.3519 14.2284C17.7159 14.0776 18.106 14 18.5 14C18.894 14 19.2841 14.0776 19.6481 14.2284C20.012 14.3791 20.3427 14.6001 20.6213 14.8787C20.8999 15.1573 21.1209 15.488 21.2716 15.8519C21.4224 16.2159 21.5 16.606 21.5 17C21.5 17.7956 21.1839 18.5587 20.6213 19.1213C20.0587 19.6839 19.2956 20 18.5 20C17.7044 20 16.9413 19.6839 16.3787 19.1213C15.8161 18.5587 15.5 17.7956 15.5 17ZM18.5 12C17.1739 12 15.9021 12.5268 14.9645 13.4645C14.0268 14.4021 13.5 15.6739 13.5 17C13.5 18.3261 14.0268 19.5979 14.9645 20.5355C15.9021 21.4732 17.1739 22 18.5 22C19.8261 22 21.0979 21.4732 22.0355 20.5355C22.9732 19.5979 23.5 18.3261 23.5 17C23.5 15.6739 22.9732 14.4021 22.0355 13.4645C21.0979 12.5268 19.8261 12 18.5 12ZM25.5 12H24.5V14H25.5C25.894 14 26.2841 14.0776 26.6481 14.2284C27.012 14.3791 27.3427 14.6001 27.6213 14.8787C27.8999 15.1573 28.1209 15.488 28.2716 15.8519C28.4224 16.2159 28.5 16.606 28.5 17C28.5 17.394 28.4224 17.7841 28.2716 18.1481C28.1209 18.512 27.8999 18.8427 27.6213 19.1213C27.3427 19.3999 27.012 19.6209 26.6481 19.7716C26.2841 19.9224 25.894 20 25.5 20H24.5V22H25.5C26.8261 22 28.0979 21.4732 29.0355 20.5355C29.9732 19.5979 30.5 18.3261 30.5 17C30.5 15.6739 29.9732 14.4021 29.0355 13.4645C28.0979 12.5268 26.8261 12 25.5 12ZM10 29C10 27.6739 10.5268 26.4021 11.4645 25.4645C12.4021 24.5268 13.6739 24 15 24H22C23.3261 24 24.5979 24.5268 25.5355 25.4645C26.4732 26.4021 27 27.6739 27 29V31H25V29C25 28.2044 24.6839 27.4413 24.1213 26.8787C23.5587 26.3161 22.7956 26 22 26H15C14.2044 26 13.4413 26.3161 12.8787 26.8787C12.3161 27.4413 12 28.2044 12 29V31H10V30V29ZM34 29C34 28.3434 33.8707 27.6932 33.6194 27.0866C33.3681 26.48 32.9998 25.9288 32.5355 25.4645C32.0712 25.0002 31.52 24.6319 30.9134 24.3806C30.3068 24.1293 29.6566 24 29 24H28V26H29C29.7956 26 30.5587 26.3161 31.1213 26.8787C31.6839 27.4413 32 28.2044 32 29V31H34V30V29Z"
                      fill="#F0FFFE"
                    />
                  </svg>
                </div>
                <div className="flex mt-2 text-[#F0FFFE] text-[32px] font-[600]">
                  Registration Fee
                </div>
                <div className="text-[#F0FFFE] text-[16px] font-[400]">
                  This member still needs to pay their registration fee. Please
                  prompt
                  <br />
                  them to make the payment to complete onboarding.
                </div>

                <div className="mt-8 mb-2">
                  <button
                    onClick={openFeePayment}
                    className="flex items-center justify-center h-[7vh] w-full bg-[#DBF227] font-[700] rounded-[5px] text-[#005C53] text-center text-[16px]"
                  >
                    Send Payment Prompt
                  </button>
                </div>
              </div>
            </div>
          )}

        <PermissionGate required={[PERMISSIONS?.MB?.CREATE_ACCOUNT]}>
          {customer?.member === false &&
            (!hasSharesAccount ||
              !hasSavingsAccount ||
              accountsArray?.length === 0) && (
              <div
                className="w-full md:w-[49%] px-3 flex flex-col rounded-lg shadow-sm"
                style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
              >
                <div className="flex flex-col gap-4 py-2 mb-10">
                  {/* <div className="flex justify-end">
                    <button
                      onClick={openCreateAccount}
                      className={`flex items-center gap-2 sm:gap-3 h-[6vh] px-2 sm:px-4 rounded-[5px] ${isAccountCreationReady ? "bg-[#005C53]" : "bg-[#9F9F9F]"}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4 sm:w-5 sm:h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                          fill="white"
                        />
                      </svg>
                      <p className="text-white text-[10px] sm:text-[12px] md:text-[14px]">
                        Create Account
                      </p>
                    </button>
                  </div> */}

                  {/* 🔒 Disabled Registration Fee Card */}
                  <div className="flex flex-col">
                    <div className="p-[10px] flex flex-col rounded-[10px] bg-[#005C53] opacity-20 pointer-events-none">
                      <div className="mt-2">
                        <svg
                          width="45"
                          height="45"
                          viewBox="0 0 45 45"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="22.5"
                            cy="22.5"
                            r="22.5"
                            fill="white"
                            fill-opacity="0.44"
                          />
                          <path
                            d="M15.5 17C15.5 16.606 15.5776 16.2159 15.7284 15.8519C15.8791 15.488 16.1001 15.1573 16.3787 14.8787C16.6573 14.6001 16.988 14.3791 17.3519 14.2284C17.7159 14.0776 18.106 14 18.5 14C18.894 14 19.2841 14.0776 19.6481 14.2284C20.012 14.3791 20.3427 14.6001 20.6213 14.8787C20.8999 15.1573 21.1209 15.488 21.2716 15.8519C21.4224 16.2159 21.5 16.606 21.5 17C21.5 17.7956 21.1839 18.5587 20.6213 19.1213C20.0587 19.6839 19.2956 20 18.5 20C17.7044 20 16.9413 19.6839 16.3787 19.1213C15.8161 18.5587 15.5 17.7956 15.5 17ZM18.5 12C17.1739 12 15.9021 12.5268 14.9645 13.4645C14.0268 14.4021 13.5 15.6739 13.5 17C13.5 18.3261 14.0268 19.5979 14.9645 20.5355C15.9021 21.4732 17.1739 22 18.5 22C19.8261 22 21.0979 21.4732 22.0355 20.5355C22.9732 19.5979 23.5 18.3261 23.5 17C23.5 15.6739 22.9732 14.4021 22.0355 13.4645C21.0979 12.5268 19.8261 12 18.5 12ZM25.5 12H24.5V14H25.5C25.894 14 26.2841 14.0776 26.6481 14.2284C27.012 14.3791 27.3427 14.6001 27.6213 14.8787C27.8999 15.1573 28.1209 15.488 28.2716 15.8519C28.4224 16.2159 28.5 16.606 28.5 17C28.5 17.394 28.4224 17.7841 28.2716 18.1481C28.1209 18.512 27.8999 18.8427 27.6213 19.1213C27.3427 19.3999 27.012 19.6209 26.6481 19.7716C26.2841 19.9224 25.894 20 25.5 20H24.5V22H25.5C26.8261 22 28.0979 21.4732 29.0355 20.5355C29.9732 19.5979 30.5 18.3261 30.5 17C30.5 15.6739 29.9732 14.4021 29.0355 13.4645C28.0979 12.5268 26.8261 12 25.5 12ZM10 29C10 27.6739 10.5268 26.4021 11.4645 25.4645C12.4021 24.5268 13.6739 24 15 24H22C23.3261 24 24.5979 24.5268 25.5355 25.4645C26.4732 26.4021 27 27.6739 27 29V31H25V29C25 28.2044 24.6839 27.4413 24.1213 26.8787C23.5587 26.3161 22.7956 26 22 26H15C14.2044 26 13.4413 26.3161 12.8787 26.8787C12.3161 27.4413 12 28.2044 12 29V31H10V30V29ZM34 29C34 28.3434 33.8707 27.6932 33.6194 27.0866C33.3681 26.48 32.9998 25.9288 32.5355 25.4645C32.0712 25.0002 31.52 24.6319 30.9134 24.3806C30.3068 24.1293 29.6566 24 29 24H28V26H29C29.7956 26 30.5587 26.3161 31.1213 26.8787C31.6839 27.4413 32 28.2044 32 29V31H34V30V29Z"
                            fill="#F0FFFE"
                          />
                        </svg>
                      </div>

                      <div className="flex mt-2 text-[#F0FFFE] text-[32px] font-[600]">
                        Registration Fee
                      </div>

                      <div className="text-[#F0FFFE] text-[16px] font-[400]">
                        This member still needs to pay their registration fee.
                        Please prompt
                        <br />
                        them to make the payment to complete onboarding.
                      </div>

                      <div className="mt-8 mb-2">
                        <button className="flex items-center justify-center h-[7vh] w-full bg-[#BFE0FD] font-[700] rounded-[5px] text-[#005C53] text-[16px]">
                          Send Payment Prompt
                        </button>
                      </div>
                    </div>

                    {/* ✅ Bottom Helper Text */}
                    <div className="mt-4 text-center text-[#6B7280] text-[14px]">
                      Savings and Shares Accounts will
                      <br />
                      automatically appear here when registration
                      <br />
                      is complete
                    </div>
                  </div>
                </div>
              </div>
            )}
        </PermissionGate>
        {/* ⚠️ Profile Incomplete Modal */}
        {isProfileIncompleteModalOpen && (
          <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div className="bg-white border border-red-500 rounded-md shadow-lg w-[90%] sm:w-[400px] p-5 relative">
              <div className="absolute top-0 left-0 w-full h-[2px] rounded-t-md" />
              <div className="flex items-center mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-7 h-7 mr-2 flex-shrink-0"
                  viewBox="0 0 24 24"
                  role="img"
                  aria-label="warning"
                >
                  <path
                    d="M12 3.2 2.3 20.8h19.4L12 3.2z"
                    fill="#ffffff"
                    stroke="#D23B3B"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                  <rect
                    x="11.3"
                    y="8.5"
                    width="1.4"
                    height="5.4"
                    rx="0.7"
                    fill="#D23B3B"
                  />
                  <circle cx="12" cy="15.6" r="0.9" fill="#D23B3B" />
                </svg>
                <h2 className="text-lg font-semibold text-gray-900">
                  Profile Incomplete
                </h2>
              </div>

              {/* Body */}
              <p className="text-gray-700 mb-2">Please provide:</p>
              <ul className="list-disc pl-6 text-gray-800 space-y-1 mb-4">
                {missingSections?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              {/* Button */}
              <div className="flex justify-end">
                <button
                  onClick={() => setIsProfileIncompleteModalOpen(false)}
                  className="bg-[#005C53] text-white px-4 py-2 rounded-md hover:bg-[#0a528d] transition"
                >
                  Go to Edit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <CreateAccounts
        isCreateAccountModalOpen={isCreateAccountModalOpen}
        closeCreateAccount={closeCreateAccount}
        handleCreateAccount={handleCreateAccount}
      />

      <AccountCreatedSuccessfully
        isAccountCreatedSuccessfully={isAccountCreatedSuccessfully}
      />
      {/* edit customer */}
      <EditPersonalInfo
        id_R="firstEditModal"
        editCustomerOpen={editCustomerOpen}
        customerEditDetails={customerEditDetails}
        setCustomerEditDetails={setCustomerEditDetails}
        handleEditCustomerDetails={handleEditCustomerDetails}
        handleCloseEditCustomerPersonalInfo={
          handleCloseEditCustomerPersonalInfo
        }
        handleOpenEmailPrompt={handleOpenEmailPrompt}
        handleOpenMobilePrompt={handleOpenMobilePrompt}
      />
      <EditNextOfKin
        id_R="firstEditModal"
        editNextOfKinOpen={editNextOfKinOpen}
        handleCloseEditNextOfKin={handleCloseEditNextOfKin}
        fullName={fullName}
        setFullName={setFullName}
        dateOfBirth={dateOfBirth}
        setDateOfBirth={setDateOfBirth}
        relationship={relationship}
        setRelationship={setRelationship}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        location={location}
        setLocation={setLocation}
        handleEditNextOfKin={handleEditNextOfKin}
        loading={loading}
      />

      <DeleteAccountPop
        isDeleteAccountOpen={isDeleteAccountOpen}
        handleDeleteAccount={handleDeleteAccount}
        closeDeleteAccountPop={closeDeleteAccountPop}
      />

      <EditAdditionalInfo
        id_R="secondEditModal"
        editAdditionalInfoOpen={editAdditionalInfoOpen}
        editAdditionalDetails={editAdditionalDetails}
        setEditAdditionalDetails={setEditAdditionalDetails}
        handleEditAdditionalInformation={handleEditAdditionalInformation}
        handleCloseEditAdditionalInfo={handleCloseEditAdditionalInfo}
        counties={counties}
      />

      {ViewCustomerDocumentOpen && selectedDocument && (
        <ViewCustomerDocument
          document={selectedDocument}
          ViewCustomerDocumentOpen={ViewCustomerDocumentOpen}
          handleCloseViewCustomerDocument={handleCloseViewCustomerDocument}
          // openAuditDocumentModal={openAuditDocumentModal}
          customerInitials={initials}
          customerName={customer}
          customerStatus={customer?.status}
          handleEditSelfie={handleEditSelfie}
          PermissionGate={PermissionGate}
          PERMISSIONS={PERMISSIONS}
        />
      )}

      <ViewID
        document={customer}
        ViewIDOpen={ViewIDOpen}
        handleCloseViewID={handleCloseViewID}
        customerInitials={initials}
        customerStatus={customer?.status}
        handleEditIdentity={handleEditIdentity}
        handleEditMetaData={handleEditMetaData}
        customer={customer}
        PermissionGate={PermissionGate}
        PERMISSIONS={PERMISSIONS}
      />
      <EditIdentity
        id_R="Modal"
        closeIDlModal={closeIDlModal}
        isIDModalOpen={isIDModalOpen}
        identificationType={identificationType}
        setIdentificationType={setIdentificationType}
        country={country}
        setCountry={setCountry}
        frontFile={frontFile}
        setFrontFile={setFrontFile}
        backFile={backFile}
        setBackFile={setBackFile}
        passportFile={passportFile}
        setPassportFile={setPassportFile}
        isContinueEnabled={isContinueEnabled}
        setIsContinueEnabled={setIsContinueEnabled}
        setIsContinueModalOpen={setIsContinueModalOpen}
        customer={customer}
        uploadKenyaIdBack={uploadKenyaIdBack}
        uploadKenyaIdFront={uploadKenyaIdFront}
        uploadPassport={uploadPassport}
      />
      <MemberDetails
        id_R="firstModal"
        id={id}
        isMemberDetailsOpen={isMemberDetailsOpen}
        closeMemberDetails={closeMemberDetails}
        firstName={firstName}
        lastName={lastName}
        middleName={middleName}
        gender={gender}
        identification={identification}
        dob={dob}
        setFirstName={setFirstName}
        setLastName={setLastName}
        setMiddleName={setMiddleName}
        setIdentification={setIdentification}
        setGender={setGender}
        setDob={setDob}
        setIsIDModalOpen={setIsIDModalOpen}
        handleNextButtonClick={handleNextButtonClick}
      />
      <EditSelfie
        isSelfieModalOpen={isSelfieModalOpen}
        selfieFile={selfieFile}
        setSelfieFile={setSelfieFile}
        closeSelfieModal={closeSelfieModal}
        openProceedModal={openProceedModal}
        customer={customer}
        handleContinueButton={handleContinueButton}
      />

      <NewSelfiePhoto
        selfiePhotoModalOpen={selfiePhotoModalOpen}
        selfieFile={selfieFile}
        setSelfieFile={setSelfieFile}
        closeSelfiePhotoModal={closeSelfiePhotoModal}
        openProceedModal={openProceedModal}
      />
      <LoadingModal
        isloadingModal={isloadingModal}
        closeLoadingModal={closeLoadingModal}
      />

      <MpesaProcessing isMpesaProcessing={isMpesaProcessing} />
      <EditMetaData
        isMetaDataOpen={isMetaDataOpen}
        identity={identity}
        setIdentity={setIdentity}
        closeMetaData={closeMetaData}
        setViewIDOpen={setViewIDOpen}
        setIsSaveChanges={setIsSaveChanges}
      />
      <SaveChanges
        isSaveChanges={isSaveChanges}
        closeSaveChanges={closeSaveChanges}
        handleSaveChangesButton={handleSaveChangesButton}
      />
      <ProceedModal
        id="proceedModal"
        isProceedModalOpen={isProceedModalOpen}
        closeSelfieModal={closeSelfieModal}
        closeProceedModal={closeProceedModal}
        handleContinueButton={handleContinueButton}
      />
      <LoadingButtons isLoadingButtons={isLoadingButtons} />
      <MpesaLoading isMpesaLoading={isMpesaLoading} />
      <ContinueModal
        isContinueModalOpen={isContinueModalOpen}
        closeContinueModal={closeContinueModal}
        handleContinueButtonClick={handleContinueButtonClick}
        customer={customer}
      />
      <FailModal isFailModal={isFailModal} closeFailModal={closeFailModal} />
      <FailPanel
        id="failPanel"
        isFailPanelOpen={isFailPanelOpen}
        closeFailPanel={closeFailPanel}
        openIdentityPanel={openIdentityPanel}
        openReviewPanel={openReviewPanel}
      />
      <LoadingPanel
        id="loadingPanel"
        isLoadingPanelOpen={isLoadingPanelOpen}
        closeLoadingPanel={closeLoadingPanel}
      />
      <DetailSavedSuccessfully
        isSavedSuccessfully={isSavedSuccessfully}
        customer={customer}
      />
      <PaymentPromptSent isPaymentPromptSent={isPaymentPromptSent} />
      <PaymentSuccessful isPaymentSuccessful={isPaymentSuccessful} />
      <PaymentNotReceived
        isPaymentNotReceived={isPaymentNotReceived}
        handleCancelTransaction={handleCancelTransaction}
        setIsPaymentNotReceived={setIsPaymentNotReceived}
        handleCheckStatus={handleCheckStatus}
      />
      <CloseAccountSuccess
        closeAccountSuccessOpen={closeAccountSuccessOpen}
        handleCloseAccountSuccess={handleCloseAccountSuccess}
      />

      <EmailPrompt
        emailPromptOpen={emailPromptOpen}
        handleCloseEmailPrompt={handleCloseEmailPrompt}
        handleOpenEmailOtp={handleOpenEmailOtp}
        handleProceed={handleProceed}
      />

      <MobilePrompt
        mobilePromptOpen={mobilePromptOpen}
        handleCloseMobilePrompt={handleCloseMobilePrompt}
        handleOpenMobileOtp={handleOpenMobileOtp}
      />

      <NewsEmailSuccessfully
        id="new"
        isNewsEmailSuccessfullyOpen={isNewsEmailSuccessfullyOpen}
      />

      <OtpEmail
        id_R="otpemail"
        otpEmailOpen={otpEmailOpen}
        handleCloseEmailOtp={handleCloseEmailOtp}
        setOtpEmailOpen={setOtpEmailOpen}
        otp={otp}
        setOtp={setOtp}
        handleOtpVerification={handleOtpVerification}
        newEmail={newEmail}
        setIsNewEmailOpen={setIsNewEmailOpen}
      />

      <NewEmail
        id_R="newEmail"
        isNewEmailOpen={isNewEmailOpen}
        setIsNewEmailOpen={setIsNewEmailOpen}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
        setEditCustomerOpen={setEditCustomerOpen}
        handleCloseNewEmail={handleCloseNewEmail}
        setEmailPromptOpen={setEmailPromptOpen}
        customerEditDetails={customerEditDetails}
      />

      <OtpMobile
        id_R="otpmobile"
        otpMobileOpen={otpMobileOpen}
        handleCloseMobileOtp={handleCloseMobileOtp}
        customerEditDetails={customerEditDetails}
        setCustomerEditDetails={setCustomerEditDetails}
      />
      <SuspendCustomerPrompt
        suspendCustomerPromptOpen={suspendCustomerPromptOpen}
        handleCloseSuspendCustomerPrompt={handleCloseSuspendCustomerPrompt}
        handleSuspendCustomer={handleSuspendCustomer}
      />

      <IdentityScanningPanel
        id_R="idModal"
        closeIdentityPanel={closeIdentityPanel}
        isIdentityPanelOpen={isIdentityPanelOpen}
        identificationType={identificationType}
        setIdentificationType={setIdentificationType}
        country={country}
        // openModal={openModal}
        setCountry={setCountry}
        // openPhoneModal={openPhoneModal}
        setIsLoadingModal={setIsLoadingModal}
        idFrontImage={idFrontImage}
        setIdFrontImage={setIdFrontImage}
        idBackImage={idBackImage}
        setIdBackImage={setIdBackImage}
        passportImage={passportImage}
        setPassportImage={setPassportImage}
        photoFile={photoFile}
        setPhotoFile={setPhotoFile}
        isContinueEnab={isContinueEnab}
        setIsContinueEnab={setIsContinueEnab}
        handleGetFilesNames={handleGetFilesNames}
        uploadKenyaIdBack={uploadKenyaIdBack}
        uploadKenyaIdFront={uploadKenyaIdFront}
        uploadPassport={uploadPassport}
      />

      <SuccessSlidePanel
        id="success-panel"
        isSuccessPanelOpen={isSuccessPanelOpen}
        closeSuccessPanel={closeSuccessPanel}
      />

      <FirstModal
        id_R="firstModal"
        id={id}
        closeReviewPanel={closeReviewPanel}
        openIdentityPanel={openIdentityPanel}
        isReviewPanelOpen={isReviewPanelOpen}
        firstName={firstName}
        lastName={lastName}
        middleName={middleName}
        gender={gender}
        identification={identification}
        dob={dob}
        setFirstName={setFirstName}
        setLastName={setLastName}
        setMiddleName={setMiddleName}
        setIdentification={setIdentification}
        setGender={setGender}
        setDob={setDob}
        username={username}
        setUsername={setUsername}
        handlePersonalInformation={handlePersonalInformation}
        loading={loading}
      />

      <AdditionalInfoPanel
        onClose={closeAdditionalInfoPanel}
        isAdditionalInfoPanelOpen={isAdditionalInfoPanelOpen}
        kraPin={kraPin}
        setKraPin={setKraPin}
        monthlyIncome={monthlyIncome}
        setMonthlyIncome={setMonthlyIncome}
        countryOfResidence={countryOfResidence}
        setCountryOfResidence={setCountryOfResidence}
        physicalAddress={physicalAddress}
        setPhysicalAddress={setPhysicalAddress}
        landmark={landmark}
        setLandmark={setLandmark}
        employment_type={employment_type}
        setEmploymentType={setEmploymentType}
        jobTitle={jobTitle}
        setJobTitle={setJobTitle}
        county={county}
        setCounty={setCounty}
        subCounty={subCounty}
        setSubCounty={setSubCounty}
        loading={loading}
        counties={counties}
        countries={countries}
        handleAdditionalInfor={handleAdditionalInfor}
      />
      <NextofKinPanel
        id_R="forthModal"
        isNextOfKinPanelOpen={isNextOfKinPanelOpen}
        closeNextOfKinPanel={closeNextOfKinPanel}
        fullName={fullName}
        setFullName={setFullName}
        dateOfBirth={dateOfBirth}
        setDateOfBirth={setDateOfBirth}
        relationship={relationship}
        setRelationship={setRelationship}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        location={location}
        setLocation={setLocation}
        handleNextOfKin={handleNextOfKin}
        loading={loading}
      />
    </div>
  );
};

export default Customer;
